(function(e){if(typeof define==="function"&&define.amd){define(["jquery"],e)}else{e(jQuery)}})(function(e){function n(e){return e}function r(e){return decodeURIComponent(e.replace(t," "))}function i(e){if(e.indexOf('"')===0){e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\")}try{return s.json?JSON.parse(e):e}catch(t){}}var t=/\+/g;var s=e.cookie=function(t,o,u){if(o!==undefined){u=e.extend({},s.defaults,u);if(typeof u.expires==="number"){var a=u.expires,f=u.expires=new Date;f.setDate(f.getDate()+a)}o=s.json?JSON.stringify(o):String(o);return document.cookie=[s.raw?t:encodeURIComponent(t),"=",s.raw?o:encodeURIComponent(o),u.expires?"; expires="+u.expires.toUTCString():"",u.path?"; path="+u.path:"",u.domain?"; domain="+u.domain:"",u.secure?"; secure":""].join("")}var l=s.raw?n:r;var c=document.cookie.split("; ");var h=t?undefined:{};for(var p=0,d=c.length;p<d;p++){var v=c[p].split("=");var m=l(v.shift());var g=l(v.join("="));if(t&&t===m){h=i(g);break}if(!t){h[m]=i(g)}}return h};s.defaults={};e.removeCookie=function(t,n){if(e.cookie(t)!==undefined){e.cookie(t,"",e.extend({},n,{expires:-1}));return true}return false}})

theme.utils = {
  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

theme.Currency = ( function() {
  
  var moneyFormat = '${{amount}}';

  function testingHere(){  }

  function formatMoney( cents, format ) {
    if (!format) {
      format = theme.settings.moneyFormat;
    }
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = theme.utils.defaultTo(precision, 2);
      thousands = theme.utils.defaultTo(thousands, ',');
      decimal = theme.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
        
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit
  }
})();

theme.cart = {
  
  getCart: function() {
    
    return $.getJSON(theme.routes.cart);
    
  },

  changeItem: function( key, qty ) {
    
    return this._updateCart({
      type: 'POST',
      url: theme.routes.cartChange,
      data: 'quantity=' + qty + '&id=' + key,
      dataType: 'json'
    });
  },

  addItemFromForm: function(data) {
    
    return this._updateCart({
      type: 'POST',
      url: theme.routes.cartAdd, 
      data: data,
      dataType: 'json'
    });
  },

  addItemFromID: function(id,qty) {
    let data = {};
    data["quantity"] = qty || 1;
    data["id"] = id;
    this._updateCart({
      type: 'POST',
      url: theme.routes.cartAdd,
      data: data,
      dataType: 'json'
    }).then(function() {
      $('body').trigger('added.ajaxProduct');
    });
  },

  _updateCart: function(params) {
    return $.ajax(params)
      .then(function(cart) {
        return cart;
      }.bind(this))
  },

  updateNote: function(note) {
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + theme.cart.attributeToString(note),
      dataType: 'json',
      success: function(cart) {},
      error: function(XMLHttpRequest, textStatus) {}
    };

    $.ajax(params);
  },

  attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return attribute.trim();
  }
}


class QtySelector {
  
  constructor( $el, options ){
    
    this.classes = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus',
      remove: '.js-qty__adjust--remove'
    };
    
    this.QtySelector( $el, options )
    
  }

  QtySelector( $el, options ) {
    
    this.$wrapper = $el;
    this.$input = $el.find( this.classes.input );
    this.$plus = $el.find( this.classes.plus );
    this.$minus = $el.find( this.classes.minus );
    this.$remove = $el.closest('.ajaxcart__cart-item').find( this.classes.remove );
    this.minValue = this.$input.attr('min') || 1;
    this.changeArray = [];
    
    this.defaults = {
      
      namespace: null,
      key: this.$input.data('id')
      
    };

    this.options = $.extend( this.defaults, options );

    this.initEventListeners();
    
  }
  
  initEventListeners () {
    
    var __this = this;
    
    this.$plus.on( 'click', function() {
      var qty = parseInt ( __this.validateQty( __this.$input.val() ) );
      __this.addQty( qty );
    } );

    this.$minus.on( 'click', function() {
      var qty = parseInt ( __this.validateQty( __this.$input.val() ) );
      __this.subtractQty( qty );
    } );
    
    this.$input.on( 'change', function() {
      var qty = parseInt ( this.validateQty( __this.$input.val() ) );
      __this.changeQty( qty );
    } )
    this.$remove.on( 'click', function() {
      __this.changeQty(0);
    } );

    
  }

  addQty( number ) {
    
    var qty = number + 1;
    this.changeQty( qty );
    
  }

  subtractQty( number ) {
    var qty = number - 1;
    if (qty <= this.minValue) {
      qty = this.minValue;
    }
    this.changeQty( qty );
  }

  changeQty ( qty ) {
    this.$input.val( qty );
    $( 'body' ).trigger( 'qty' + this.options.namespace, [this.options.key, qty] );
  }

  validateQty (number) {
    if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
      
      // We have a valid number!
      
    } else {
      
      // Not a number. Default to 1.
      number = 1;
      
    }
    
    return number
  }
}

class Stockists {
  
  constructor( el ) {
    
    var __this = this;
    
    this.el = el;
    
    this.zoom = 11;
    
    this.initSection();
    
    this.init();
    
    this.el.find('.map--container').each(function(){
      $.data($(this), 'stockistStick', new StockistStick($(this)));
    });
    
  }
  
  initButtons(){
    
    var __this = this;
    
    this.stockItem=$('.stockist--area');
    this.h4=$('h4[data-lat]');
    
    this.el.find('.stockists-item[data-lat], h4[data-lat]').each(function(){
      
      $(this).off('click');
      $(this).on('click', function(){
        
        var originLocation=[Number($(this).attr('data-lat')), Number($(this).attr('data-long'))];
        
        __this.map.setCenter({lat: Number($(this).attr('data-lat')), lng: Number($(this).attr('data-long')) } );
        __this.map.setZoom( Number($(this).attr('data-zoom')));
        
        if($(this).is('h4')) __this.runTabs($(this));
        
      })
    })
  }
  
  runTabs(el){
    
    var __this=this;
    
    this.h4.removeClass('active');
    el.addClass('active');
    
    if(el.parent().is('ul') ){
      var index=el.index();
      this.stockItem.eq(index)
        .addClass('active')
        .siblings()
          .removeClass('active'); 
    }else{
      this.stockItem.each(function(){
        $(this).addClass('active')
      })
    }
  }
  
  initSection(){
    
    var __this = this;
    
    var source = $( '#StockistsBaseTemplate' ).html();
    var template = Handlebars.compile( source );
    
    var context = [];
    
    this.el.html( '' );
    
    var html = template( context );
    
    $( html ).appendTo( this.el );
    
    this.mapEl = this.el.find( '.map' );
    this.input = this.el.find( 'input' );
    this.stockists = {}
    this.stockistsClosest = $( '.stockists--closest' );
    
    this.input.attr( 'id', 'pac-input' );
    this.input.attr( 'type', 'text' );
    this.input.attr( 'placeholder', 'Enter an address' );
    
    $( window ).trigger( 'retrigger' );
    
    $( '#shopify-section-stockists' ).find( '.stockists-content' ).clone().appendTo( this.el.find( '.stockists--other' ) );
        
  }
  
  init(){
    
    var __this = this;
    
    var mapCenter = $( '[data-type="stockists-center"]' );
  
    var someJSON = {
      "type": "FeatureCollection", 
      "features": [
        
      ]
    }
    
    this.stockistsCenter = $( '[data-type="stockists-center"]' );
    this.stockists = $( '[data-type="stockist"]' );
    
    this.stockists.each( function( index ){
      
      var lat=Number($(this).attr('data-latitude'));
      var long=Number($(this).attr('data-longitude'));
      var zoom=Number($(this).attr('data-zoom'));
      var title=$(this).attr('data-title');
      
       var intJSON = {
        "geometry": {
            "type": "Point",
            "coordinates": [ long, lat
            ]
        },
        "type": "Feature",
        "properties": {
            "name": title,
            "address": $( this ).html(),
            "storeid": index + 1, 
            "long": long,
            "lat": lat, 
            "zoom": zoom,
            "icon": "https://cdn.shopify.com/s/files/1/0667/3966/7197/files/trans.png"
        }
      }
      
      someJSON.features.push( intJSON );
      
    } );
    
    var myJSON = someJSON;
    
    this.map = new google.maps.Map( this.mapEl[0], {
      
      zoom: Number(this.stockistsCenter.attr('data-zoom')),
      center: { lat: Number( this.stockistsCenter.attr( 'data-latitude' ) ), lng: Number( this.stockistsCenter.attr( 'data-longitude' ) ) },
      disableDefaultUI: true, // a way to quickly hide all controls
      //scaleControl: true,
      zoomControl: true,
      styles: mapStyle
      
    } );
    
    this.initButtons();
  
    // Load the stores GeoJSON onto the map.
    this.markerCollection = this.map.data.addGeoJson( myJSON, { idPropertyName: 'storeid'} );
  
    const apiKey = 'AIzaSyB7xbzC6d94bnjAD3f2YYCWk_xky1SKD10';
    const infoWindow = new google.maps.InfoWindow();
  
    // Show the information for a store when its marker is clicked.
    
    var markerEl = [];
    
    for (var i = 0, length = this.markerCollection.length; i < length; i++) {
      
      var item = this.markerCollection[i];
        
      markerEl[ i ] = new StockistOverlay( this.map, item.getGeometry().get(), '<div class="stockist-marker" style="align-items: center; background: #333; border-radius: 99px; color: #fff; display: flex; height: 20px; justify-content: center; transform: translate(-50%, -50%); width: 20px;">' + item.getProperty('storeid') + '</div>' ); 
      
      if ( item.getProperty( 'icon' ) ) {
        
        this.map.data.setStyle( function( item ) {
          
          return {
            
            icon: item.getProperty('icon')
            
          };
          
        } );
        
      }
        
    }
    
    this.map.data.addListener( 'click', ( event ) => {
      
      const category = event.feature.getProperty( 'category' );
      const name = event.feature.getProperty( 'name' );
      const description = event.feature.getProperty( 'description' );
      const hours = event.feature.getProperty( 'hours' );
      const phone = event.feature.getProperty( 'phone' );
      const position = event.feature.getGeometry().get();
      const content = `
        <h2>${name}</h2><p>${description}</p>
        <p><b>Open:</b> ${hours}<br/><b>Phone:</b> ${phone}</p>
      `;
  
      infoWindow.setContent( content );
      infoWindow.setPosition( position );
      infoWindow.setOptions( { pixelOffset: new google.maps.Size( 0, -30 ) } );
      infoWindow.open( map );
      
    } );
    
    /* user input stuff ); */
    
    // Build and add the search bar
    
    /*
    
    const card = document.createElement( 'div' );
    const titleBar = document.createElement( 'div' );
    const title = document.createElement( 'div' );
    const container = document.createElement( 'div' );
    const input = document.createElement( 'input' );
    const options = {
      types: ['address'],
      componentRestrictions: {country: 'au'},
    };
  
    card.setAttribute( 'id', 'pac-card' );
    title.setAttribute( 'id', 'title' );
    title.textContent = 'Find the nearest store';
    titleBar.appendChild( title );
    container.setAttribute( 'id', 'pac-container' );
    input.setAttribute( 'id', 'pac-input' );
    input.setAttribute( 'type', 'text' );
    input.setAttribute( 'placeholder', 'Enter an address' );
    container.appendChild( input );
    card.appendChild( titleBar );
    card.appendChild( container );
    
    */
    
    //map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);
    
    //document.body.appendChild( card );
    
    const options = {
      types: ['address'],
      componentRestrictions: {country: 'au'},
    };
  
    // Make the search bar into a Places Autocomplete search bar and select
    // which detail fields should be returned about the place that
    // the user selects from the suggestions.
    const autocomplete = new google.maps.places.Autocomplete( this.input[0], options );
  
    autocomplete.setFields(
        ['address_components', 'geometry', 'name']);

    /* set marker */
    
    // Set the origin point when the user selects an address
    
    const originMarker = new google.maps.Marker({ map: this.map });
    originMarker.setVisible(false);
    let originLocation = this.map.getCenter();
  
    autocomplete.addListener('place_changed', async () => {
      
      originMarker.setVisible( false );
      originLocation = this.map.getCenter();
      const place = autocomplete.getPlace();
  
      if ( ! place.geometry ) {
        
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert('No address available for input: \'' + place.name + '\'');
        return;
        
      }
  
      // Recenter the map to the selected address
      
      originLocation = place.geometry.location;
      this.map.setCenter( originLocation );
      this.map.setZoom(9);
  
      originMarker.setPosition( originLocation );
      originMarker.setVisible( true );
  
      // Use the selected address as the origin to calculate distances
      // to each of the store locations
      const rankedStores = await __this.calculateDistances( this.map.data, originLocation );
      
      __this.showStoresList( this.map.data, rankedStores);
      __this.initButtons();
      
      return;
      
    } );
  
  }
  
  async calculateDistances( data, origin ) {
    
    const stores = [];
    const destinations = [];
  
    // Build parallel arrays for the store IDs and destinations
    
    data.forEach((store) => {
      const storeNum = store.getProperty('storeid');
      const storeLoc = store.getGeometry().get();
      
      stores.push(storeNum);
      
      destinations.push( storeLoc );
      
    });
  
    // Retrieve the distances of each store from the origin
    // The returned list will be in the same order as the destinations list
    const service = new google.maps.DistanceMatrixService();
    const getDistanceMatrix =
      (service, parameters) => new Promise((resolve, reject) => {
        service.getDistanceMatrix(parameters, (response, status) => {
          if (status != google.maps.DistanceMatrixStatus.OK) {
            reject(response);
          } else {
            
            const distances = [];
            const results = response.rows[0].elements;
            for (let j = 0; j < results.length; j++) {
              const element = results[j];
              const distanceText = element.distance.text;
              const distanceVal = element.distance.value;
              const distanceObject = {
                storeid: stores[j],
                distanceText: distanceText,
                distanceVal: distanceVal,
              };
              distances.push( distanceObject );
            }
  
            resolve(distances);
          }
        });
      });
  
    const distancesList = await getDistanceMatrix(service, {
      
      origins: [origin],
      destinations: destinations,
      travelMode: 'DRIVING',
      unitSystem: google.maps.UnitSystem.METRIC,
      
    });
  
    distancesList.sort((first, second) => {
      return first.distanceVal - second.distanceVal;
    });
  
    return distancesList;
  }
  
  showStoresList( data, stores ) {
    
    if (stores.length == 0) {
      console.log('empty stores');
      return;
    }
    
    let panel = document.createElement('div');
    // If the panel already exists, use it. Else, create it and add to the page.
    if (document.getElementById('panel')) {
      panel = document.getElementById('panel');
      // If panel is already open, close it
      if (panel.classList.contains('open')) {
        panel.classList.remove('open');
      }
    } else {
      panel.setAttribute('id', 'panel');
      const body = document.body;
      document.body.appendChild( panel );
    }
  
  
    // Clear the previous details
    
    while ( panel.lastChild ) {
      
      panel.removeChild(panel.lastChild);
      
    }
  
    var source = $( '#StockistsTemplate' ).html();
    var template = Handlebars.compile( source );
    
    var stockists = [];
    
    stores.forEach( ( store, index ) => {
      
      var int=(parseFloat(store.distanceText));
            
      if(index<3) {
      
        var id = data.getFeatureById( store.storeid );
        var currentStore = data.getFeatureById( store.storeid );
        var name = currentStore.getProperty( 'name' );
        var address = currentStore.getProperty( 'address' );
        var lat = currentStore.getProperty( 'lat' );
        var long = currentStore.getProperty( 'long' );
        var zoom=currentStore.getProperty('zoom');
        
        stockists.push( {
  		    
  		    id: store.storeid,
      	  name: name, 
      	  address: address,
      	  distance: store.distanceText,
      	  lat: lat,
      	  long: long,
      	  zoom: zoom,
      	  
    	  } )
    
      }
      
    } );
    
       
    var context = { "stockists": stockists };
    
    var html = template( context );
    
    this.stockistsClosest.html( html ); 
  
    // Open the panel
    panel.classList.add('open');
  
    return;
  }
  
}

class CartDrawer {
  
  constructor () {
    
    var __this = this;
    
    this.config = {
      namespace: '.ajaxcart'
    };
  
    this.selectors = {
      
      drawer: '#CartDrawer',
      container: '#CartContainer',
      template: '#CartTemplate',
      templateEmpty: '#CartTemplateEmpty',
      cartBubble: '.cart-link__bubble'
      
    };
    
    this.cartDrawer();
    this.configureLogic();
  }
  
  configureLogic(){
    
    var __this = this;
    
    this.cartClass = '#CartContainer';
    this.btnClass = '.cart[href="/cart"]';
    this.closeClass = '[href="/close"]';
    
    this.cart = $( this.cartClass );
    this.btn = $( this.btnClass );
    this.close = this.cart.find( this.closeClass );
    
    $( 'body' ).on( 'click', function( e ){
      
      var el = $( e.target );
      
      if( el.is( __this.btnClass ) ||  el.closest( __this.btnClass ).length ){
        
        e.preventDefault()
        __this.toggleCart(  );
        return;
        
      }
      
      if( $( 'body' ).is( '[data-cart-active]' ) ){
        
        if( ! el.closest( __this.cartClass ).length ) {
          __this.toggleCart();
          return;
        }
        if( el.closest( __this.closeClass ).length ) {
          e.preventDefault()
          __this.toggleCart();
          return;
        }
        
      }
      
    } )
    
  }
  
  toggleCart(){
    
    if( $( 'body' ).is( '[data-cart-active]' ) ) $( 'body' ).removeAttr( 'data-cart-active' );
    else $( 'body' ).attr( 'data-cart-active', 'active' );
    
  }
  
  cartDrawer() {
    
    var __this = this;
    
    this.status = {
      loaded: false,
      loading: false
    };

    //this.drawer = new theme.Drawers( 'CartDrawer', 'cart' );

    // Prep handlebars template
    var source = $(this.selectors.template).html();
    this.template = Handlebars.compile( source );

    // Build cart on page load so it's ready in the drawer
    
    theme.cart.getCart().then( function( data ){ 
      
      __this.buildCart( data );
      
    } );

    this.initEventListeners(  );
  }
  
  newBuildCart( data ) {
    
  }
      
  initEventListeners( ) {
    
    $('body').on( 'updateCart' + this.config.namespace, this.initQtySelectors.bind(this));
    $('body').on( 'updateCart' + this.config.namespace, this.updateCartNotification.bind(this));
    $('body').on( 'added.ajaxProduct', function(evt, returnFocusEl) { 
      theme.cart.getCart().then( function( cart ) {
        this.buildCart( cart, true, returnFocusEl );
        $( 'body' ).attr( 'data-cart-mobile', true );
      }.bind( this ) );
    }.bind( this ) );
    $('#CartDrawer').on( 'click', '.cart__continue', () => {
      this.drawer.close();
    })
  }
  
  buildCart( cart, openDrawer, returnFocusEl ) {
    
    var __this = this;
    
    this.emptyCart(  );

    if ( cart.item_count === 0 ) {
      
      //$( this.selectors.container ).append('<div class="drawer__scrollable"><p class="appear-animation appear-delay-3">Cart Empty</p></div>');
      
      var source=$(this.selectors.templateEmpty).html();
      var template=Handlebars.compile(source);
      $(this.selectors.container).append(template);
      
      return
      
    } else {
      
      var items = [];
      var item = {};
      var data = {};
      var animation_row = 1;

      $.each( cart.items, function( index, product ) {

        var prodImg;
        
        if ( product.image !== null ) {
          
          prodImg = product.image.replace(/(\.[^.]*)$/, "_x100$1");
          
        } else {
          
          prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
          
        }
        
        if ( product.properties !== null ) {
          
          $.each(product.properties, function( key, value ) {
            
            if (key.charAt(0) === '_' || !value) {
              
               delete product.properties[key];
               
             }
             
          } );
          
        }

        // If we have line-item discount, add formattedAmount to discount object
        
        var amount = 0;
        
        item = {
          key: product.key,
          url: product.url,
          img: prodImg,
          name: product.product_title,
          variation: product.variant_title,
          properties: product.properties,
          itemQty: product.quantity,
          price: theme.Currency.formatMoney( product.price, theme.settings.moneyFormat ),
          unitPrice: theme.Currency.formatMoney( product.unit_price, theme.settings.moneyFormat ),
          unitBase: theme.Currency.getBaseUnit( product ),
          discountedPrice: theme.Currency.formatMoney( ( product.price - ( product.total_discount / product.quantity ) ), theme.settings.moneyFormat),
          discounts: product.line_level_discount_allocations,
          discountsApplied: product.line_level_discount_allocations.length === 0 ? false : true,
          vendor: product.vendor
        };

        items.push( item );
        
      } );

      // If we have cart discount, add a formattedAmount to the discount object
      
      var cartAmount = 0;

      data = {
        
        items: items,
        note: cart.note,
        cartDiscounts: cart.cart_level_discount_applications,
        cartDiscountsApplied: cart.cart_level_discount_applications.length === 0 ? false : true,
        totalPrice: theme.Currency.formatMoney( cart.total_price, theme.settings.moneyFormat )
        
      };
      
      $( this.selectors.container ).append( this.template( data ) );

    }

    this.status.loaded = true;
    this.loading(false);
    $('body').trigger( 'updateCart' + this.config.namespace, cart );
    
    $('.cart--bubble').text( cart.item_count );

  }
  
  initQtySelectors () {
    
    var __this = this;
    
    $( this.selectors.container ).find( '.js-qty__wrapper' ).each( function( index, el ) {
      
      var selector = new QtySelector( $( el ), {
        namespace: '.cart-drawer'
      });
      
    }.bind( this ) );

    $( 'body' ).on( 'qty.cart-drawer', this.updateItem.bind( this ) );
  }

  updateItem( evt, key, qty ) {
    
    if (this.status.loading) {
      
      return;
      
    }

    this.loading(true);

    theme.cart.changeItem( key, qty )
      .then( function( cart ) {
        
        this.updateSuccess( cart );
        
      }.bind( this ) )
      .catch(function( XMLHttpRequest ) {
        
        this.updateError( XMLHttpRequest )
        
      }.bind( this ) )
      .always( function( ) {
        
        this.loading( false );
        
      }.bind( this ) );
  }

  loading ( state ) {
    
    this.status.loading = state;

    if ( state ) {
      $( this.selectors.container ).addClass('is-loading');
    } else {
      $( this.selectors.container ).removeClass('is-loading');
    }
  }

  emptyCart () {
    
    $( this.selectors.container ).empty();
    
  }

  updateSuccess( cart ) {
    
    if( $( 'body' ).is( '.template-cart' ) ) location.reload();
    
    else this.buildCart(cart)
    
  }

  updateError ( XMLHttpRequest ) {
    
    if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
      
      // console.warn(XMLHttpRequest.responseJSON.description);
      
    }
  }

  updateCartNotification ( evt, cart ) {
    
    if (cart.items.length > 0) {
      
      $( this.selectors.cartBubble ).addClass('cart-link__bubble--visible');
      
    } else {
      
      $( this.selectors.cartBubble ).removeClass('cart-link__bubble--visible');
      
    }
    
  }
  
}


class FilterState {
  
  constructor(){
    
    var __this = this;
    
    this.btnClass='.filter-buttons li' ;
    this.filterClass='.cc-product-filter';
    this.formClass='> .wrapper';
    this.sortBtn='[data-button="sort"]';
    
    this.initFilter();
    
    $(window).on('scroll', function(){})
    
    $(window).on ('reinitFilter', function(){
      __this.initFilter()
    }) 
  }
  
  initFilter(){
    
    var __this=this;
    
    this.btn=$(this.btnClass);
    this.filter=$(this.filterClass);
    this.filterInner=this.filter.find(this.formClass);
    
    this.btn.off('click');
    $('html').off('click');
    /*
    this.btn.on('click', function(){
      //__this.runClick($(this));
    });
    */
    $('html').on('click', function(e){
      __this.runClick($(e.target));
    });
    
    this.setHeight();
    
  }
  
  runClick(el){
    var __this=this;
    if(el.is('[data-button')){
      if(el.is('[data-button="sort"]')){
        if( $('body').is('[data-filter="sort"]')) {
          $( 'body' ).removeAttr('data-filter');
        } else {
          $( 'body' ).attr('data-filter', 'sort');
        }
      }else{
        if( $('body').is('[data-filter="filter"]')) {
          $( 'body' ).removeAttr('data-filter');
        } else {
          $( 'body' ).attr('data-filter', 'filter');
        }
        //$('body').trigger('scroll');
      }
      this.setHeight();
      return;
    }
    
    if(!el.closest('#FacetsForm').length && $('body').is('[data-filter]')){
      $('body').removeAttr('data-filter');
      this.setHeight();
    }
  }
  
  setHeight(){
    
    if($('body').is('[data-filter="filter"]')){
      var filterTop=this.filter.position().top;
      var filterInner=this.filterInner.outerHeight();
      var filterTotal=filterTop + filterInner;
    }else{
      var filterTop=this.filter.position().top;
      var filterInner=0;
      var filterTotal=filterTop;
    }
    
    document.documentElement.style.setProperty('--box-top', filterTop+'px');
    document.documentElement.style.setProperty('--box-offset', filterInner+'px');
    document.documentElement.style.setProperty('--box-total', filterTotal+'px');
  }
}

class BoxScroll {
  
  constructor( boxClass, elClass, stopClass ){
    
    var __this = this;
    
    this.boxClass = boxClass;
    this.elClass = elClass;
    this.stopClass = stopClass;
    
    this.setupElements();
    
    $( window ).on( 'scroll resize load', function(){
      
      __this.runScroll();
      
    } )
    
    $( window ).on( 'reinitFilter' , function(){
      
      __this.setupElements();
      
    } )
    
    this.runScroll()
    
  }
  
  setupElements(){
    
    var __this = this;
    
    this.box = $( this.boxClass ).first();
    this.el = $( this.elClass ).first();
    
    this.lastEl = this.el.find( '> *' ).first();
    this.stopEl = $( this.stopClass );
    this.scrollPos = $( window ).scrollTop();
    
    this.runScroll();
    
  }
  
  updateStop( stop ) {
    
    this.stopEl = stop;
    
    this.runScroll();
    
  }
  
  runScroll(){
    
    var __this = this;
    
    this.scrollPos=$( window ).scrollTop();
    this.scrollPos=this.scrollPos<0 ? 0 : this.scrollPos;
    
    var filterHeight = parseInt( getComputedStyle(document.documentElement).getPropertyValue( '--box-offset' ) );
    
    var elTop = this.box.offset().top;
    
    var top = parseInt( getComputedStyle(document.documentElement).getPropertyValue( '--nav-height' ) );
    
    var intTop = elTop - top;
    
    var bottom = intTop + this.stopHeight() - this.boxHeight();
    
    if( this.scrollPos < intTop ){ 
      
      this.el.css( 'transform', 'translate(0, 0)' );
      this.el.removeClass( 'fixed' );
            
    } else if ( this.scrollPos>bottom ) {
      
      this.el.css( 'transform', 'translate(0, ' + bottom + 'px)' );
      this.el.removeClass( 'fixed' );
      
    } else {
      
      this.el.css( 'transform', 'translate(0, ' + top + 'px)' );
      this.el.addClass( 'fixed' );
      
    }
    
  }
  
  stopHeight(){
    
    var height = $( this.stopEl ).offset().top + $( this.stopEl ).outerHeight();
    
    return height;
    
  } 
  
  boxHeight(){
    
    var height = this.lastEl.position().top + this.lastEl.outerHeight(  );
    return height;
    
  }
}

class ProductScroll {
  
  constructor(boxEl, el){
    
    var __this = this;
    
    /*
    this.boxClass = boxClass;
    this.elClass = elClass;
    */
    this.isThumbs=boxEl.is('.product-area__thumbs') ? 1 : 0;
    this.setupElements(boxEl, el);
    if(this.isThumbs) this.setupThumbs();
    this.runScroll()
    
    $(window).on( 'scroll resize load', function(){  
      __this.runScroll();
    } )
    
  }
  setupThumbs(){
    var __this=this;
    this.imgs=$('.theme-img');
    this.thumbs=$('.product-area__thumbs__thumb');
    this.thumbs.each(function(index){
      $(this).data('index', index);
      $(this).find('a').on('click', function(e){
        e.preventDefault();
        var index=$(this).parent().data('index');
        var top=__this.imgs.eq(index).offset().top; /*-getComputedStyle(document.documentElement).getPropertyValue('--header-final')*/
        $('html,body').animate({
          scrollTop: top },
        800);
      })
    });
  }
  setupElements(boxEl,el){
    
    var __this = this;
    
    this.box = boxEl;
    this.el = el;
    
    this.lastEl = this.el.find( '> *' ).first();
    this.scrollPos = $( window ).scrollTop();
    
    this.runScroll();
    
  }
  
  runScroll(){
    
    var __this = this;
    
    this.scrollPos = $( window ).scrollTop();
    
    var boxTop = this.box.offset().top;
    var boxHeight = this.box.outerHeight();
    
    var elHeight = this.boxHeight();
    
    var navTop = parseInt( getComputedStyle(document.documentElement).getPropertyValue( '--header-final' ) );
    var elTrack = boxHeight - elHeight;
    var boxBottom = boxTop + elTrack;
    
    var intTop = boxTop - navTop;
    var intBottom = boxBottom - navTop;
    
    //if( this.el.is( '.product-form--inner' ) ) console.log( navTop + '  ' + intBottom + ' : ' + boxHeight ) 
    
    if( this.scrollPos < intTop ){ 
      this.el.css( 'transform', 'translate(0, 0)' );
      this.el.removeClass( 'fixed' );
      this.el.removeClass( 'absolute' )
    } else if ( this.scrollPos > intBottom ) {
      this.el.css( 'transform', 'translate(0, 0)' );
      this.el.removeClass( 'fixed' );
      this.el.addClass( 'absolute' );
    } else {
      this.el.css( 'transform', 'translate(0, ' + navTop + 'px)' );
      this.el.addClass( 'fixed' );
      this.el.removeClass( 'absolute' ); 
    }
    if(this.isThumbs) this.runThumbs();
  }
  
  runThumbs(){
    var __this=this;
    if(typeof this.imgs=='undefined') return;
    var wasFound=0;
    this.imgs.each(function(index){
      var img=$(this)
      var top=img.offset().top;
      var bottom=top+img.height();
      var half=scrollTop+($(window).height()/2);
      if(half>top&&half<bottom) {
        __this.thumbs.eq(index).addClass('active').siblings().removeClass('active');
        wasFound=1;
      }
    });
    if(!wasFound) {
      this.thumbs.removeClass('active');
    }
  }
  
  boxHeight(){
    
    //var height = this.lastEl.position().top + this.lastEl.outerHeight(  );
    height = this.el.outerHeight();
    return height;
    
  }
}

class ProxyTag {
  
  constructor( el ){
    
    var __this = this;
    this.rootEl = el;
    this.setupProxy();
    
    $(window).on('filterComplete load', function(){
      __this.setupProxy();
      __this.testSizes();
    });
  }
  
  testSizes(){
    var input=$('input[name="filter.v.option.size"]');
    var sizeArr=[];
    input.each(function(){
      if($(this).is(':checked')) sizeArr[sizeArr.length]=$(this).attr('value');
    })
    
    if(sizeArr.length){
      $('.product-block').each(function(){
        var el=$(this);
        var show=0;
        $.each(sizeArr, function(index, value){
          var has=el.find('.avail--true[value="'+value+'"]');
          if(has.length) show=1;
        })
        if(! show) el.hide();
      })
    }
  }
  
  setupProxy() {
    
    
    
    var __this = this;
    
    this.el = this.rootEl.clone();
    
    this.inputName = '[name*="filter.p.tag"]';
    this.inputSelect = '.cc-checkbox__input' + this.inputName + '';
    this.input = $( this.inputSelect );
    
    this.form = $( '#FacetsForm' );
    this.tag = this.el.find( '.cc-checkbox-proxy' );
    this.sort = $( '.cc-product-filter__sort-by' );
    
    this.baseEl = $( this.inputName ).first().closest( '.filter-column' );
    this.baseEl.hide();
    
    this.el.appendTo( this.form );
    
    this.setupRel();
    
    this.checkAvailable();
    
    this.tag.on( 'click', function(){
      
      $( this ).data( 'rel' ).parent().trigger( 'click' );
      
      __this.checkActive( $( this ) );
      
      
    } )
    
    $( window ).trigger( 'reinitFilter' );
    
  }
  
  checkAvailable( ){
    
    var __this = this;
    
    this.tag.each( function(){
      
      if( $( this ).data( 'rel' ).length ) $( this ).removeClass( 'unavailable' );
      else {
        
        $( this ).addClass( 'unavailable' );
        
      }
      
    } )
    
    if( ! this.el.find( '.cc-checkbox-proxy:not(.unavailable)' ).length ){
      
      this.el.hide();
      
    }
    
  }
  
  checkActive( el ){
    
    if( el.data( 'rel' ).is( ':checked' ) ) {
        
        el.addClass( 'active' );
        
      } else {
        
        el.removeClass( 'active' );
        
      }
    
  }
  
  setupRel(){
    
    var __this = this;
    
    this.input.each( function(){
      
      $( this ).attr( 'data-value', $( this ).attr( 'value' ).toLowerCase() );
      
    } )
    
    this.tag.each( function(){
      
      var val = $.trim( $( this ).text().split( ' -- ' )[0] ).toLowerCase();
      
      $( this ).attr( 'value', val );
      
      var elRel = $( __this.inputSelect + '[data-value="' + val + '"]' );
      
      $( this ).data( 'rel',  elRel );
      
      __this.checkActive( $( this ) );
      
    } );
    
  }
  
}




class ProxySwatch {
  
  constructor(){
    
    var __this = this;
    
    this.rootEl = $( '.proxy--swatch' ).first();
    
    this.setupProxy();
    
    $( window ).on( 'filterComplete', function(){
      
      __this.setupProxy();
      
    } );
    
  }
  
  setupProxy(){
    
    var __this = this;
    
    this.el = this.rootEl.clone();
    this.inputSelect = '.cc-checkbox__input[name*="custom.swatch"]';
    this.input = $( this.inputSelect );
    this.form = $( '#FacetsForm' );
    this.swatch = this.el.find( '.cc-checkbox-proxy' );
    this.sort = $( '.cc-product-filter__sort-by' );
    
    this.el.appendTo( this.form );
    
    this.baseEl = $( '[name*="custom.swatch"]' ).first().closest( '.filter-column' );
    this.baseEl.hide();
    
    this.setupRel();
    
    this.checkAvailable();
    
    this.swatch.on( 'click', function(){
      
      $( this ).data( 'rel' ).parent().trigger( 'click' );
      
      __this.checkActive( $( this ) );
      
    } )
    
    $( window ).trigger( 'reinitFilter' );
    
  }
  
  checkAvailable( ){
    
    var __this = this;
    
    this.swatch.each( function(){
      
      if( $( this ).data( 'rel' ).length ) $( this ).removeClass( 'unavailable' );
      else {
        
        $( this ).addClass( 'unavailable' );
        
      }
      
    } )
    
    if( ! this.el.find( '.cc-checkbox-proxy:not(.unavailable)' ).length ){
      
      this.el.hide();
      
    }
    
  }
  
  checkActive( el ){
    
    if( el.data( 'rel' ).is( ':checked' ) ) {
        
        el.addClass( 'active' );
        
      } else {
        
        el.removeClass( 'active' );
        
      }
    
  }
  
  setupRel(){
    
    var __this = this;
    
    this.input.each( function(){
      
      $( this ).attr( 'data-value', $( this ).attr( 'value' ).toLowerCase() );
      
    } )
    
    this.swatch.each( function(){
      
      var val = $.trim( $( this ).text().split( ' -- ' )[0] ).toLowerCase();
      
      $( this ).attr( 'value', val );
      
      var elRel = $( __this.inputSelect + '[data-value="' + val + '"]' );
      
      $( this ).data( 'rel',  elRel );
      
      __this.checkActive( $( this ) );
      
    } );
    
  }
  
}

class StickElement {
  
  constructor( root, el, scroll, distance ){
    
    var __this = this; 
    
    this.root = root;
    
    this.el = el;
    
    this.scroll = scroll;
    
    this.distance = distance;
    
    this.scrollPos = $( window ).scrollTop();
    
    this.elTop = this.el.offset().top
    
    this.windowHeight = $( window ).innerHeight();
    
    $( window ).on( 'resize', function(){
      
      __this.elTop = __this.el.offset().top
      __this.windowHeight = $( window ).innerHeight();
      
    } )
    
    $( window ).on( 'scroll', function(){
      
      __this.scrollPos = $( window ).scrollTop();
      
      __this.runScroll();
      
    } );
    
  }
  
  updateDistance( distance ) {
    
    this.distance = distance;
    this.elTop = this.el.offset().top;
     
  }
  
  returnMid ( el ){
    
    return el.offset().left + ( el.outerWidth() / 2 );
    
  }
  
  runScroll(){
    
    var __this = this;
    
    var calcDistance = this.scrollPos - this.elTop;
    var finalDistance = this.elTop + this.distance;
    
    if( ( this.scrollPos + this.windowHeight ) >= this.el.offset().top ){
      
      this.root.updateScroll();
      
    }
    
    if( this.scrollPos >= this.elTop && this.scrollPos < ( this.elTop + this.distance ) ) {
      
      this.scroll.css( 'transform', 'translate3d( 0px, 0px, 0px )' );
      
      this.scroll.addClass( 'fixed' ); 
      
    } else if ( this.scrollPos < this.elTop ) {
      
      this.scroll.removeClass( 'fixed' );
      
      this.scroll.css( 'transform', 'translate3d( 0px, 0px, 0px )' );
      
    } else {
      
      this.scroll.css( 'transform', 'translate3d( 0, ' + this.distance + 'px, 0px )' );
      
      this.scroll.removeClass( 'fixed' );
      
    }
    
  } 
}

class InstagramFeed {
  
  constructor() {
    
    var __this = this;
    
    this.testCounter = 0;
    this.testTimeout = 3500
    this.testLimit = 5;
    
    this.elClass = '.fs-timeline';
    
    this.base = $( '.instagram-feed' );
    this.scroll = this.base.find( '.testing' ).first();
    
    this.runTimer();
    
    $( window ).on( 'resize, retrigger', function(){
      
      __this.updateScroll();
      
    } )
    
    $( 'body' ).on( 'load', function(){
      
      __this.updateScroll();
      
    } );
    
  }
  
  updateScroll(){
    
    var __this = this;
    
    if( typeof $.data( __this.scroll, 'scroll' ) != 'undefined' ){
      
      var distance = this.el.outerHeight() - this.scroll.height();
      
      $.data( __this.scroll, 'scroll' ).updateDistance( distance );
      
    }
    
  }
  
  runTimer(){
    
    var __this = this;
    
    if( this.testCounter < this.testLimit ) setTimeout( function(){ __this.testInstagram(); }, __this.testTimeout )
    
  }
  
  testInstagram() {
    
    var __this = this;
    
    if( $( this.elClass ).length ) this.setupInstagram();
    
    else {
      
      this.testCounter++;
      runTimer();
      
    }
  }
  
  setupInstagram(){
    
    var __this = this;
    
    this.el = $( this.elClass );
    this.block = this.el.find( '> *' );
    this.distance = this.el.height() - this.scroll.height();
    
    //$.data( this.scroll, 'scroll', new StickElement( this, this.scroll.parent(), this.scroll, this.distance ) );
    
  }
  
}

class ClothesHR {
  
  constructor( el ) {
  
    var __this = this;
    
    this.el = el;
    
    this.flex = this.el.find( '.clothes-hr-flex' );
    
    this.block = this.flex.find( '> div' ).first();
    
    this.blockWidth = 0;
    this.prevScroll = $( window ).scrollTop();
    this.currPos = 0;
    this.distance = .25;
    
    this.timeZoneCheck();
    
  }
    
  timeZoneCheck(  ){
  
    var __this = this;
    
    if ( $( 'body' ).is( '[data-timezone]' ) ){
      
      this.setupSection(  );
      
    } else {
      
      $( window ).on( 'timezone', function(){
        
        __this.setupSection(  )
        
      } );
      
    }
    
  }
  
  setupSection(){
    
    var __this = this;
    
    this.blockWidth = this.block.first().outerWidth();
    
    for( var x = 0; x < 3; x++ ){
      
      this.block.first().clone().appendTo( this.flex );
      
    }
    
    this.interval = setInterval( function(){ __this.runSection() }, 50 )
    
  }
  
  runSection (){
    
    var __this = this;
    
    var currScroll = $( window ).scrollTop();
    var extra = Math.abs( currScroll - this.prevScroll ) / 12;
    var newPos = this.currPos - extra - this.distance;
    
    var overflow = newPos + this.block.first().outerWidth();
    
    newPos = overflow < 0 ? overflow : newPos;
    
    this.flex.css( 'transform', 'translate(' + newPos + 'px, 0)' );
    
    this.prevScroll = currScroll;
    this.currPos = newPos;
    
    // if( overflow < 0 ) { clearInterval( this.interval ); console.log( 'over ' + overflow ); }
    
  }
  
}

class ClothesThatLogo {
  
  constructor(  ){
    
    var __this = this; 
    
    this.el = $( '.clothes-logo' );
    
    this.timer = null;
    
    if( this.el.length < 2 ){
      
      $( window ).on( 'headerDuplicated', function(){
        
        __this.setupLogo();
        
      } )  
      
    } else {
      
      this.setupLogo()
      
    }
    
  }
  
  setupLogo(){
    
    var __this = this;
    
    this.el = $( '.clothes-logo [data-section-type="clothes-that-travel"]' );
    this.elArray = $( '.scroll-banner--clothes h2 [data-section-type="clothes-that-travel"], #page-content .clothes-hr-container' );
    this.scrollPos = $( window ).scrollTop();
    
    this.timeZoneCheck();
    
  }
  
  checkVisibility(){
    
    var __this = this;
    
    var isVisible = 1;
    
    
    
    this.elArray.each( function(){
      
      var elPos = $( this ).offset().top + ($( this ).outerHeight() / 2 );
      var top = __this.scrollPos;
      var bottom = $( window ).innerHeight() + top;  
      
      if( elPos > top && elPos < bottom ) isVisible = 0;
      
    } )
    
    if( isVisible ){
      
      if( ! this.el.is( '.active' ) ){
        
        this.el.addClass( 'active' );
      
        this.startTimeZone(  );
        
      }
      
    } else {
      
      if( this.el.is( '.active' ) ){
      
        this.el.removeClass( 'active' );
        
        this.endTimeZone(  )
        
      }
      
    }
    
  }
  
  timeZoneCheck(){
    
    var __this = this;
    
    if ( $( 'body' ).is( '[data-timezone]' ) ){
      
      this.setupTimeZone();
      
    } else {
      
      $( window ).on( 'timezone', function(){
        
        __this.setupTimeZone()
        
      } );
      
    }
    
  }
  
  setupTimeZone(){
    
    var __this = this;
    this.timeZone = this.el.first().find( '> *' );
    this.timeZoneCount = this.timeZone.length;
    this.counter = 1;
    
    this.checkVisibility();
    
    $( window ).on( 'scroll', function(){
      
      __this.scrollPos = $( window ).scrollTop();
    
      __this.checkVisibility();    
    
    } )
    
  }
  
  startTimeZone(){
    
    this.counter = 0;
    
    this.runTimeZone();
    
  }
  
  endTimeZone(){
      
      clearTimeout( this.timer );
      
  }
  
  runTimeZone(){
    
    var __this = this;
    
    var reTimer = 0;
    
    this.el.each( function(){
      
      var currEl = $( this ).find( '> *' ).eq( __this.counter );
    
      currEl
        .addClass( 'start' )
        .addClass( 'active' )
        
      currEl[0].offsetHeight;
      
      currEl
        .removeClass( 'start' )
        .siblings()
          .removeClass( 'active' );
          
      reTimer = currEl.is( '.base' ) ? 8000 : 2500;
      
    } );
    
    this.counter = ( this.counter + 1 ) % this.timeZoneCount;
    
    this.timer = setTimeout( function(){ __this.runTimeZone(); }, reTimer );
    
  }
}

class ClothesThatTravel {
  
  constructor(  ){
    
    var __this=this;
    this.isInit=0;
    this.timezones=$('meta[data-timezone]');
    this.elements=$('[data-section-type="clothes-that-travel"]');
    
    this.elements.each(function(){
      __this.setElements($(this));
    });
    
    $('body' ).attr('data-timezone', 1);
    $( window ).trigger( 'timezone' ); 
    
    this.runTimeZone();
    setInterval( function(){__this.runTimeZone(); }, 1000);
    
  }
  
  setElements(el){
    
    var __this = this;
    
    this.timezones.each(function(){
      var intEl=$('<span class="timezone" data-value="'+$(this).attr('data-location').toLowerCase()+'"></span>');
      intEl.appendTo(el);
    });
    
    el.attr('data-timezone-init', true);
    
  }
  
  runTimeZone(  ){
    
    var __this = this;
    
    var baseTime = new Date(  );
    
    this.timezones.each( function(  ){
      
      var optionsDay = { timeZone: $( this ).attr( 'data-timezone' ), weekday: 'short' };
      var optionsDate = { timeZone: $( this ).attr( 'data-timezone' ), month: 'short', day: 'numeric' };
      var optionsTime = { timeZone: $( this ).attr( 'data-timezone' ), hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' };
      
      var day = baseTime.toLocaleString( "en-AU", optionsDay );
      var date = baseTime.toLocaleString( "en-AU", optionsDate );
      var time = baseTime.toLocaleString( "en-AU", optionsTime );
      
      var el = $( '[data-value="' + $( this ).attr( 'data-location' ).toLowerCase() + '"]' )
      
      el.html( '<b class="location">' + $( this ).attr( 'data-location' ) + '</b><b class="day">' + day + '</b><b class="date">' + date + '</b><b class="time">' + time + '</b>' );
      
      if( ! this.isInit ) {
        
        el.each( function(){
          
          $( this ).width( $( this ).outerWidth() );
          
        } )
        
      }
      
    } );
    
    this.isInit = 1;
    
  }
  
}

class AutoScrollBanner {
  
  constructor(el){
    
    var __this=this;
    
    this.el=el;
    this.container=this.el.find('.scroll-banner--flex');
    this.box=this.el.find('.scroll-banner--box');
    this.cursor=this.el.find('.cursor');
    
    this.blockWidth=0;
    this.prevScroll=$(window).scrollTop();
    this.currPos=0;
    this.distance=.5;
    this.token=0;
    this.finalX=0;
    this.finalY=0;
    this.finalOpacity=0;
    this.currX=0;
    this.currY=0;
    this.currOpacity=0;
    this.clearTimer=null;
    
    this.initPosition();
    this.initValues();
    this.initImg();
    
    this.scrollPos=$(window).scrollTop();
    
    $(window).resize(function(){
      __this.initValues();
    });
    
    this.el.hover(function(){
      __this.finalOpacity=1;
    }, function(){
      __this.finalOpacity=0;
    })
    
    $(window).on('scroll', function(){
      
      //__this.finalOpacity=0;
      
      if(__this.el.is('[data-visible]')){
        if(__this.interval==null) __this.interval=setInterval( function(){ __this.runSection() }, 36 );
      } else {
        if(__this.interval!=null){
          clearInterval(__this.interval);
          __this.interval=null;
        }
      }
    })
    this.el.on('mousemove', function(e){
      __this.finalX=e.pageX;
      __this.finalY=e.pageY;
    })
    
    this.interval=setInterval( function(){ __this.runSection() }, 36 )
    
  }
  
  initImg(){
    
    var __this=this;
    
    this.el.find('img').each(function(){
      if(this.complete) __this.loadImg($(this));
      else {
        $(this).on('load', function(){
          __this.loadImg($(this));
        });
      }
    })
  }
  
  loadImg(el){
    el.closest('.scroll-banner--item').attr('data-complete', 1); 
    
  }
  
  initPosition(){
    
    var __this=this;
    
    this.box.clone().appendTo(this.container);
    
    this.el.find('.scroll-banner--item a').hover(function(){
      
      var intEl=$(this).find('.product-item').clone();
      intEl.addClass('banner-product');
      
      intEl
        .addClass('start')
        .appendTo(__this.cursor);
        
      intEl[0].offsetHeight;
      
      intEl
        .removeClass('start')
        .addClass('active');
        
      //__this.finalOpacity=1;
      
      __this.cursor.addClass('active');
      
    }, function(){
      
      //__this.finalOpacity=0;
      
      clearTimeout(__this.clearTimer);
      
      __this.cursor.find('.active').addClass('end');
      
      __this.clearTimer=setTimeout(function(){ __this.cursor.find('.end').remove(); }, 1000);
      
      __this.cursor.removeClass('active');
      
    })
  }
  
  initValues(){
    
    var __this=this;
    
    this.boxWidth=this.box.width();
    this.negativeBoxWidth=-1*this.boxWidth;
    this.container.width(this.boxWidth*2);
    
  }
    
  runSection(){
    
    var __this=this;
    
    var currScroll=$(window).scrollTop();
    var extra=Math.abs(currScroll-this.prevScroll)/12;
    var newPos=this.currPos-extra-this.distance;
    
    var overflow=newPos+this.box.first().outerWidth();
    
    newPos=overflow<0 ? overflow:newPos;
    
    this.container.css('transform', 'translate('+newPos+'px, 0)');
    
    this.prevScroll=currScroll;
    this.currPos=newPos;
    
    this.lerper();
    
  }
  
  lerper(){
    
    var intX=this.currX+((this.finalX-this.currX)*.125);
    var intY=this.currY+((this.finalY-this.currY)*.125);
    var intOpacity=this.currOpacity+((this.finalOpacity-this.currOpacity)*.125);
    
    this.el.find('.cursor')
      .css('position', 'absolute')
      .css('top', intY)
      .css('left', intX)
      .css('opacity', intOpacity)
      .css('pointer-events', 'none');
    
    this.currX=intX;
    this.currY=intY;
    this.currOpacity=intOpacity;
  }
  
}

class ScrollBanner {
  
  constructor(el){
    
    var __this=this;
    
    this.el=el; 
    
    this.mode=this.el.find('[data-section-mode]').attr('data-section-mode');
    
    this.elScroll=this.el.find('.scroll-banner--container');
    this.elWrapper=this.el.find('.scroll-banner--wrapper');
    this.elFlex=this.el.find('.scroll-banner--flex');
    this.elBlock=this.el.find('.scroll-banner--item');
    this.blockLength=this.elBlock.length;
    this.elContent=this.el.find('.scroll-banner--content');
    this.elTop=0;
    this.distance=0;
    this.scrollPos=$(window).scrollTop();
    this.index = 1;
    this.h3=this.el.find('h3');
    this.contentInit=0;
    this.headingInit=0;
    
    if(this.mode=='reveal'){
    
      this.elFlexReveal=this.elFlex.clone().insertBefore(this.elScroll);
      this.elFlexReveal
        .attr('data-proxy', 'proxy')
        .addClass('scroll-banner--flex__reveal');
        
    }
    
    this.resizeTimer = null;
    
    this.setupImageLoading();
    this.setupWindowHeight();
    //this.setupHeights();
    this.setupContent();
    this.runScroll();
    this.setIndex();
    
    $(window).on('resize retrigger', function(){
      
      clearTimeout(__this.resizeTimer);
      __this.resizeTimer=setTimeout(function(){if(!isMobile){__this.setupWindowHeight();}}, 250);
    } )
    
    $( window ).on( 'scroll', function(){
      
      // __this.h3.text(__this.elScroll.closest('.shopify-section').height()+ ' height');
      
      if(__this.elBlock.length>1){
        __this.scrollPos=$( window ).scrollTop();
        __this.scrollPos=__this.scrollPos<0 ? 0 : __this.scrollPos;
        __this.runScroll();
      }
    } );
    this.el.find('img').on('load', function(){
      clearTimeout(__this.resizeTimer);
      __this.resizeTimer=setTimeout(function(){__this.setupWindowHeight();}, 250);
    })
    
    this.timeZoneCheck();
    
  }
  setupImageLoading(){
    
    var __this=this;
    
    this.el.find('img').each(function(){
      if($(this)[0].complete){ 
        __this.runImageLoaded($(this));
        return;
      }
      $(this).on('load', function(){ __this.runImageLoaded($(this));});
    })
  }
  
  runImageLoaded(el){
    var __this=this;
    
    el.attr('data-load', true);
  }
  
  setupWindowHeight(){
    
    var __this=this;
    
    if(this.mode=='reveal') this.setupRevealHeights();
      
    if(isMobile) this.elFlex.addClass('scroll-banner--flex__opacity');
    else{
      
      if(this.mode!='opacity'){
        this.elFlex.removeClass('scroll-banner--flex__opacity');
      }
    }
    
    this.windowHeight=$(window).innerHeight();
    document.documentElement.style.setProperty('--scroll-window-height', this.windowHeight+'px');
    
    this.elTop = this.el.offset().top;
    
    if(this.mode=='reveal'){
      var intLast=this.elFlexReveal.find('>div').last();
      var flexHeight=this.elFlexReveal.height()-intLast.height()+Number(intLast.attr('data-margin'));
      this.distance=flexHeight;
    }else if(this.mode=='opacity'){
      this.distance=(this.elBlock.length - 1)*$(window).height();
    }else{
      this.distance=this.returnMid(this.elBlock.last())-this.returnMid(this.elBlock.first());
    }
    var overflow=this.elScroll.height()-this.windowHeight;
    overflow=overflow<0 ? 0:overflow;
    this.el.height(this.windowHeight+this.distance+overflow);
    
  }
  
  setupRevealHeights(){
    
    var __this=this;
    
    var cont=this.elFlexReveal.find('.scroll-banner--item__container');
    this.elFlexReveal.css('top', 'auto');
    
    cont.each(function(index){
      
      var rel=__this.elBlock.eq($(this).index());
      var center=rel.offset().top+(rel.height()/2);
      
      if(isMobile) $(this).find('>*').first().css('top', center);
      
      var int=$(this).find('>div');
      var intHeight=int.height();
      var index=$(this).index();
      
      if(index==0){
        var off=int.offset().top-__this.scrollPos;
        __this.elFlexReveal.css('top', off);
      }
      
      var intMargin=0;
      if(index){
        var prevHeight=$(this).prev().height();
        if(intHeight>prevHeight){
          intMargin=(intHeight-prevHeight)/2;
        }
      }
      $(this)
        .attr('data-margin', intMargin)
        .css('margin-top', intMargin)
        .height(int.height());
      
      $(this)[0].offsetHeight;
        
      this.siblingHeight=intHeight;
    })
    
  }
  
  timeZoneCheck(){
    
    var __this = this;
    if ($('body').is('[data-timezone]')){
      this.setupTimeZone();
    } else {
      $(window).on('timezone', function(){
        __this.setupTimeZone()
      });
    }
  }
  
  setupTimeZone(){
    
    var __this=this;
    this.timeZone=this.el.find( '.timezone' );
    this.timeZoneCount=this.timeZone.length;
    this.counter=0;
    
    this.runTimeZone();
    
  }
  
  runTimeZone(){
    
    var __this=this;
    
    this.counter=(this.counter+1)%this.timeZoneCount;
    var currEl=this.timeZone.eq(this.counter);
    
    currEl
      .addClass('start')
      .addClass('active')
    currEl[0].offsetHeight;
    currEl
      .removeClass('start')
      .siblings()
        .removeClass('active');
        
    setTimeout(function(){__this.runTimeZone();}, 4000);
    
  }
  
  setupContent() {
    
    var __this = this;
        
    if(! this.contentInit){ 
      this.el.attr('data-content-init', true);
      this.contentInit=1;
    }
  }
  
  setupHeights(){
    
    var __this = this;
    
  }
  
  returnMid (el){
    return el.offset().left+(el.outerWidth()/2);
  }
  
  runScroll(){
    
    var __this = this;
    
    var calcDistance = this.scrollPos - this.elTop;
    var finalDistance = this.elTop + this.distance;
    
    if( this.scrollPos >= this.elTop && this.scrollPos < ( this.elTop + this.distance ) ) {
      
      this.elFlex.css( 'transform', 'translate3d( -' + calcDistance + 'px, 0px, 0px )' );
      this.elScroll.css( 'transform', 'translate3d( 0px, 0px, 0px )' );
      this.elScroll.addClass( 'fixed' ); 
      
    } else if (this.scrollPos < this.elTop ) {
      
      this.elFlex.css( 'transform', 'translate3d( 0px, 0px, 0px )' );
      this.elScroll.removeClass( 'fixed' );
      
    } else {
      
      this.elFlex.css( 'transform', 'translate3d( -' + this.distance + 'px, 0px, 0px )' );
      this.elScroll.css( 'transform', 'translate3d( 0, ' + this.distance + 'px, 0px )' );
      this.elScroll.removeClass( 'fixed' );
      
    }
    var index=Math.floor(this.blockLength * (this.scrollPos-this.elTop)/finalDistance); 
    index=index<0 ? 0 : index;
    index=index>=this.blockLength ? this.blockLength-1 : index;
    if(this.blockLength==1) this.elBlock.first().addClass('active');
    
    var sectionPos=100 * (this.scrollPos-this.elTop)/finalDistance;
    var sectionPath='polygon(0 0, ' + sectionPos + '% 0,  ' + sectionPos + '% 100%, 0 100%, 0 0)';
    
    var sectionOpacity=sectionPos>0&&sectionPos<100 ? 1: 0;
    
    document.documentElement.style.setProperty( '--scroll-path', sectionPath + '' );
    document.documentElement.style.setProperty( '--scroll-opacity', sectionOpacity );
    
    if(this.index!=index) {
      this.index=index;
      this.setIndex();
    }
    
  }
  
  setIndex(){
    
    var __this=this;
    this.elFlex.find('> *').eq(this.index)
        .addClass('active')
        .siblings()
          .removeClass('active');
    
  }
  
}

class ScrollMenu {
  
  constructor(){
    
    var __this = this;
    
    this.announce=$('.cc-announcement');
    this.header=$('[data-section-type="header"] > *').first().find('.site-control');
    this.footer=$('footer.site-footer');
    
    this.headerInner=this.header.find('.site-control__inner');
    this.inner=this.announce.find(' > * ').first();
    this.scrollOffset=600;
    this.scrollPos=$(window).scrollTop();
    this.runScroll();
    
    $(window).on('scroll', function(){
      __this.scrollPos=$( window ).scrollTop();
      __this.runScroll();
    });
    $(window).on('resize', function(){ __this.calcPageHeight(); });
    this.calcPageHeight();
  }
  
  runScroll(){
    
    var __this=this;
    var innerHeight=this.inner.length ? this.inner.outerHeight() : 0;
    var total=this.headerInner.outerHeight()+innerHeight;
    document.documentElement.style.setProperty('--header-total-height', total+'px');
    document.documentElement.style.setProperty('--header-total-height', total+'px');
    document.documentElement.style.setProperty('--header-final', innerHeight+'px');
    
    this.calcPageHeight();
    
    if(this.scrollPos > this.scrollOffset){
      document.documentElement.style.setProperty('--header-height', '0px');
      document.documentElement.style.setProperty('--nav-height', this.header.outerHeight()+'px');
    } else {
      document.documentElement.style.setProperty('--header-height', innerHeight+'px');
      var totalHeight = this.header.outerHeight();
      document.documentElement.style.setProperty('--nav-height', totalHeight+'px');
    }
  }
  
  calcPageHeight(){
    var total=this.inner.outerHeight();
    var pageMin=$(window).height()-total;
    document.documentElement.style.setProperty('--page-min-height', pageMin+'px');
  }
}

class DropDown {
  
  constructor( el, nav ){
    
    var __this = this;  
    this.el = el;
    this.header = this.el.find( '.drop--down__header' );
    this.findElClass='.site-control__inline-links a';
    this.find=$(this.findElClass);
    this.findClass = '[data-dropdown-related]';
    
    this.nav = nav.clone();
    if(!this.el.is('.theme--light')) this.nav.addClass('site-header--dark');
    this.nav.appendTo( this.header ); 
    this.nav.find( '.cc-announcement' ).remove();
    this.nav.find( '.fixed' ).removeClass( 'fixed' );
    this.nav.removeClass( 'fixed' );
    
    this.btnArray=[];
    
    this.setupRelated();
    
    if(typeof this.related==null) return;
    
    this.el.hover(function(){
      __this.startDropdown();
    }, function(){
      __this.beginCloseDropdown();
    })
  }
  
  willToggle(el){
    
    var __this=this;
    
    var toggle=0;
    
    if(!el.closest('[data-section-type="dropdown"]').length&&this.el.is('[data-active]')) toggle=1;
    
    $.each(__this.btnArray, function(index, value){
      if(el.is(value)||el.closest('a').is(value)) toggle=1;
    })
    
    return toggle;
  }
  
  setupRelated(){
    
    var __this=this;
    this.rel=this.el.attr('data-related').toLowerCase();
    
    this.related=null;
    var elEq=0;
    
    this.find.each(function(){ 
      
      var compare=$.trim($(this).text().toLowerCase());
      
      if(compare==__this.rel) { 

        __this.related=$(this);
        __this.btnArray[__this.btnArray.length]=$(this);
        $(this).attr( 'data-dropdown-related', 'true' );
        $(this).data('related', __this.el);
        var eq=$(this).parent().index();
        __this.nav.find(__this.findElClass).eq(eq)
          .attr('data-dropdown-proxy', true)
          .addClass('current');
          
        $(this).hover(function(){
          __this.startDropdown();
        }, function(){
          __this.beginCloseDropdown();
        })
      }
    } )
    
    if(this.related == null) return;
  }
  
  toggleDropDown(){
    
    var __this = this;
    
    if(this.el.is('[data-active]') ) this.el.removeAttr('data-active');
    else this.el.attr('data-active', 'active');
    
  } 
  
  startDropdown(){
    clearTimeout(this.timer);
    $('body').attr('dropdown-active', 'active');
    this.el.attr('data-active', 'active');
    if(!this.el.parent().siblings().find('.drop--down').length) return;
    this.el.parent().siblings().find('.drop--down').data('dropdown').closeDropdown();
  }
  beginCloseDropdown(){
    var __this=this;
    __this.timer=setTimeout(function(){ __this.closeDropdown(); }, 250);
  }
  closeDropdown(){
    this.el.removeAttr('data-active');
    if(!$('.drop--down[data-active]').length) $('body').removeAttr('dropdown-active');
  }
}

class ScrollClassOld {
  
  constructor(){
    
    var __this = this;
    
    //this.elLight=$('.site-header--light'); // to make the stuff below work, delete this line and uncomment the other stuff... 
    
    this.sizeTimer = null
    this.navClass='.site-control__inline-links';
    
    this.sections=$('#page-content .shopify-section');
    this.header=$('[data-section-type="header"]');
    this.header.css('padding', '0');
    this.footer=$('[data-section-type="footer"]');
    this.elLight=$('.site-header--light');
    this.elLightContainer=this.elLight.parent();
    this.elDarkContainer=this.elLightContainer.clone().appendTo(this.header);
    this.elDark=this.elDarkContainer.find('.site-header--light');
    this.elDark.find('#site-control').removeAttr('id');
    
    this.pathCnt=0;
    
    $('.drop--down').each( function(){
      $(this).data('dropdown', new DropDown($(this), __this.elDark));
    });
    
    this.elDark.clone()
      .prependTo('#page-menu')
        .find('#site-control').removeAttr('id');
    
    $(window).trigger('headerDuplicated');
    
    this.darkArray=[];
    this.lightArray=[];
    
    this.darkMatrix=[];
    this.lightMatrix=[];
    
    this.scrollPos=$(window).scrollTop();
    
    this.setItems();
    
    // to make the clip path things work, remove the 1==2
    if(this.darkArray.length && 1==2){ 
      this.continueItems();
    } else {
      this.elDark.hide();
    }
    
    setTimeout( function(){
      __this.elLight.attr('data-init', true);
      __this.elDark.attr('data-init', true);
    }, 125);
    
    this.setupDropDownProxy();
    this.setupHoverProxy();
    this.setupIcons();
  }
  
  setupIcons(){
    var __this=this;
    $(this.navClass).find('[data-dropdown-related],[data-dropdown-proxy]').each(function(){
      $('<span class="icon icon--smaller">'+iconChevronDown()+'</span>').appendTo($(this));
    })
  }
  
  setupHoverProxy(){
    var __this=this;
    
    $(this.navClass).each(function(){
      $(this).find('a').each(function(index){
        $(this).attr('data-hover-proxy', index);
      })
    })
    $('[data-hover-proxy]').hover(function(){
      $('[data-hover-proxy="'+__this.returnEq($(this))+'"]').addClass('hover');
    },function(){
      $('[data-hover-proxy="'+__this.returnEq($(this))+'"]').removeClass('hover');
    })
  }
  
  returnEq(el){
    return(el.attr('data-hover-proxy'));
  }
  
  setupDropDownProxy(){
    
    var __this=this;
    
    this.lightDrop=this.elLight.find( '.contains-children' )
    this.darkDrop=this.elDark.find( '.contains-children' );
    
    for(var x=0; x<this.lightDrop.length; x++) {
      this.lightDrop.eq(x).data('rel', this.darkDrop.eq(x));
      this.darkDrop.eq(x).data('rel', this.lightDrop.eq(x));
    }
    
    this.runDropDownProxy(this.lightDrop);
    this.runDropDownProxy(this.darkDrop);
    
  }
  
  runDropDownProxy(el){
    
    var __this=this;
    
    el.hover( function(){
      $(this).data('rel').addClass('hover');
    }, function(){
      $(this).data('rel').removeClass('hover');
    });
  }
  
  continueItems(){
    
    var __this=this;
    
    this.setLimits();
    
    $(window).on('resize retrigger load', function(){
      clearTimeout(__this.sizeTimer);
      __this.sizeTimer=setTimeout(function(){ __this.setLimits(); __this.setPaths(); }, 2500);
    }) 
    
    $(window).on('scroll', function(){
      //__this.scrollPos=$(window).scrollTop();
      //__this.setPaths();
      
    })
  }
  
  setItems(){
    
    var __this = this;
    
    var itemArray = []
    this.sections.each( function(){
      if($(this).find('.is--dark').length) $(this).addClass('has--dark');
    } )
    
    // this finds elements
    
    this.sections.each(function(){
      itemArray=[];
      if($(this).is('.is--dark')){
        __this.darkArray.push($(this))
      }else{
        var el=$(this).find('.is--dark');
        el.each(function(){
          __this.darkArray.push($(this))
        });
      }
    });
  }
  
  setLimits(){
    var __this=this;
    
    /*
      this.darkMatrix=[];
      this.lightMatrix=[];
    */
    
    this.setPaths();
    
  }
  
  setPaths(){
    
    var __this=this;
    
    var lightPath='0% 0%, ';
    var darkPath='0% 0%, ';
    
    var lastBottom=0;
    var lastTop=0;
    
    var isInit=0;
    
    this.sections.each(function(index){
      
      var el=$(this)
      
      var top=$(this).offset().top;
      var bottom=top+$(this).outerHeight();
      
      /*
      
      if(!index){
        if(!$(this).is('.is--dark')&&!$(this).is('.has--dark')){
          top=0;
        }
      }else{
      
        if($(this).is('.is--dark')||$(this).is('.has--dark')){
          if(!isInit) {
            isInit=1;
            lightPath+='0% 0%, 100% 0%, 100% '+top+'px, 0% '+top+'px, ';
          }
        }
      }
      
      */
      
      if(!index) top=0;
      //console.log(index+'  ' +top);
        
      if($(this).is('.is--dark')){
        darkPath+='0% '+top+'px, 100% '+top+'px, 100% '+bottom+'px, 0% '+bottom+'px, ';
      }else if($(this).is('.has--dark')){
        
        lightPath+='0% '+top+'px, 100% '+top+'px, 100% '+bottom+'px, 0% '+bottom+'px, 0% '+top+'px, ';
        
        el.find('.is--dark').each(function(){
          var elTop=$(this).offset().top;
          var elBottom=elTop+$(this).outerHeight();
          var elLeft=$(this).offset().left;
          var elRight=elLeft+$(this).outerWidth();
          
          $(this).attr('data-pos', elLeft+', '+elRight+', '+elTop+', '+elBottom+' ---')
          
          darkPath+='0% '+elTop+'px, '+elLeft+'px '+elTop+'px, '+elLeft+'px '+elBottom+'px, '+elRight+'px '+elBottom+'px, '+elRight+'px '+elTop+'px, '+elLeft+'px '+elTop+'px, 0% '+elTop+'px, ';
          
          lightPath+='0% '+top+'px, '+elLeft+'px '+top+'px, '+elLeft+'px '+elBottom+'px, '+elRight+'px '+elBottom+'px, '+elRight+'px '+elTop+'px, '+elLeft+'px '+elTop+'px, '+elLeft+'px '+top+'px, 0% '+top+'px, ';
          
        });
      }else {
        var lightStr='0% '+top+'px, 100% '+top+'px, 100% '+bottom+'px, 0% '+bottom+'px, 0% '+top+'px, ';  
        //console.log(lightStr);
        lightPath+=lightStr;
      }
    });
    lightPath+='0% 0%';
    darkPath+='0% 0%';
    /*
    console.log(isInit + '   init');
    console.log(lightPath);
    console.log('break');
    console.log(darkPath);
    */
    this.elDark.addClass('site-header--dark');
    //if(isInit) this.elLightContainer.css('clip-path', 'polygon('+lightPath+')');
    this.elLightContainer.css('clip-path', 'polygon('+lightPath+')'); 
    this.elDarkContainer.css('clip-path', 'polygon('+darkPath+')'); 
    
    this.pathCnt++;
    
  }
  
  setLimitsOLD() {
    
    var __this = this;
    
    this.darkMatrix = [];
    this.lightMatrix = [];
    
    var prevTop=0;
    var prevBottom=0;
    
    var stop=this.footer.offset().top + this.scrollPos;
    for(var x=0; x<this.darkArray.length; x++){
      
      var top=this.darkArray[x][0].offset().top;
      var bottom=top+this.darkArray[x][0].outerHeight();
      
      // test to see if two sections are in the same row
      var testDifference=Math.abs(top-prevTop)+Math.abs(bottom-prevBottom)
      
      if(testDifference>50){
      
        if(!x){
          this.lightMatrix.push([0, top]);
        }else{
          this.lightMatrix.push([prevBottom, top]);
        }
        this.darkMatrix.push([top, bottom]);
        prevTop=top;
        prevBottom=bottom;
      }
    }
    this.lightMatrix.push([bottom, stop]);
    this.elTop=this.elLight.offset().top-this.scrollPos;
    
    this.setPaths();
    
  }
  
  setPathsOLD(){
    
    var __this = this;
    
    var lightPath='';
    var darkPath='';
    var bottom=0;
    this.scrollPos=0;
    
    for(var x=0; x<this.lightMatrix.length; x++){
      
      var top=this.lightMatrix[x][0];
      bottom=this.lightMatrix[x][1];
      
      if(x) lightPath+= ', ';
      lightPath+='0% '+top+'px, 100% '+top+'px, 100% '+bottom+'px, 0% '+bottom+'px';
    }
    lightPath += ', 0% '+bottom+'px, 0% 0px';
    
    for(var x=0; x<this.darkMatrix.length; x++){
      
      var top=this.darkMatrix[x][0];
      bottom=this.darkMatrix[x][1];
      
      if(x) darkPath+=', ';
      darkPath+='0% '+top+'px, 100% '+top+'px, 100% '+bottom+'px, 0% '+bottom+'px';
    }
    darkPath+=', 0% ' + bottom + 'px, 0% 0px';
    
    //this.header.css( 'position', 'fixed' );
    //this.header.css( 'width', '100%' );
    
    this.elDark.addClass('site-header--dark');
    this.elLightContainer.css('clip-path', 'polygon('+lightPath+')'); 
    this.elDarkContainer.css('clip-path', 'polygon('+darkPath+')'); 
  }  
}


class ScrollClass {
  
  constructor(){
    
    var __this = this;
    
    this.elLight=$('.site-header--light'); 
    
    this.sizeTimer = null
    this.navClass='.site-control__inline-links';
    
    this.sections=$('#page-content .shopify-section');
    this.header=$('[data-section-type="header"]');
    this.header.css('padding', '0');
    this.footer=$('[data-section-type="footer"]');
    this.elLight=$('.site-header--light');
    this.elLightContainer=this.elLight.parent();
    this.elDarkContainer=this.elLightContainer.clone().addClass('alt').appendTo(this.header);
    this.elDark=this.elDarkContainer.find('.site-header--light');
    this.elDark.addClass('site-header--dark');
    this.elDark.find('#site-control').removeAttr('id');
    
    this.isInit=0;
    
    this.pathCnt=0;
    
    $('.drop--down').each( function(){
      $(this).data('dropdown', new DropDown($(this), __this.elDark));
    });
    
    this.elDark.clone()
      .prependTo('#page-menu')
        .removeClass('site-header--dark')
        .find('#site-control').removeAttr('id');
    
    $(window).trigger('headerDuplicated');
    
    this.darkArray=[];
    this.darkLimitArray=[];
    
    this.scrollPos=$(window).scrollTop();
    
    this.setItems();
    
    // to make the clip path things work, remove the 1==2
    if(this.darkArray.length){ 
      this.continueItems();
    } else {
      this.elLight.attr('data-init', true);
      this.elDark.attr('data-init', true);
      //this.elDark.hide();
    }
    
    this.setupIcons();
    
    $('.site-header--light').hover(function(){
      $('body').attr('data-header', 'true')
    },function(){
      $('body').removeAttr('data-header');
    })
  }
  
  scrollFunction(){
    var top=parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-height'));
    //console.log(top);
  }
  
  setupIcons(){
    var __this=this;
    $(this.navClass).find('[data-dropdown-related],[data-dropdown-proxy]').each(function(){
      $('<span class="icon icon--smaller">'+iconChevronDown()+'</span>').appendTo($(this));
    })
  }
  
  continueItems(){
    
    var __this=this;
    
    $(window).on('resize retrigger', function(){
      clearTimeout(__this.sizeTimer);
      __this.sizeTimer=setTimeout(function(){ 
        __this.setLimits(); }, 1000);
    }) 
    $(window).on('scroll', function(){
      __this.setLimits();
    })
    this.sizeTimer=setTimeout(function(){ 
        __this.setLimits(); }, 1000);
  }
  
  setLimits(){
    var __this=this;
    var nav=parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-height'));
    this.darkLimitArray=[];
    
    $.each(this.darkArray, function(index, el){
      var offset=$(this).next().is('.has--dark') ? 0 : nav;
      var top=$(this).offset().top;
      var bottom=top+$(this).outerHeight()-offset;
      var limitArray=[top, bottom];
      
      __this.darkLimitArray.push(limitArray);
    })
    
    this.testLimits();
  }
  
  testLimits(){
   var __this=this;
   var announce=parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
   var top=$(window).scrollTop()+announce+1; 
   var isLight=1;
   $.each(this.darkLimitArray, function(index, arr){
     if(top>=arr[0]&&top<arr[1]){
       isLight=0;
     }else{  }
   })
   if(!isLight) $('body').attr('data-bg', 'dark');
   else $('body').attr('data-bg', 'light');
   
   if(! this.isInit) {
     setTimeout( function(){
       __this.isInit=1;
       __this.elLight.attr('data-init', true);
       __this.elDark.attr('data-init', true);
       $(window).on('scroll', function(){
         __this.scrollFunction();
       })
     }, 125);
   }
  }
  
  setItems(){
    
    var __this = this;
    
    var itemArray = []
    this.sections.each( function(){
      if($(this).find('.is--dark').length) $(this).addClass('has--dark');
    } )
    
    // this finds elements
    this.sections.each(function(){
      itemArray=[];
      if($(this).is('.has--dark')){
        __this.darkArray.push($(this))
      }
    });
  }
}



class Related {
		
	constructor( ) {
		
		var __this = this;
		
		this.base = window.location.origin; 
		
		this.tagSelector = '.product-list meta[data-related]:not([data-completed]), .product-area meta[data-related]:not([data-completed])';
		this.collectionSelector = '.product-list';
		this.productSelector = '.product-block';
		//this.productFormSelector = '.product-detail__form';
		this.productFormSelector = '.product-area';
		this.relatedProductSelector = '.product-list .product-block';
		this.titleSelector = 'span.title';
		this.relatedTag = 'data-related';
		
		this.isChecking = 0;
		
		this.tag = null;
		
		$( 'body' ).on( 'test.colors', function(){
  		
  		setTimeout( function(){ __this.runCheck(); }, 1000 );
  		
		} ) 
		
		this.runCheck();
		
	} 
	
	runCheck( ) {
		
		var __this = this;
		
		if( this.isChecking ) return false;
		
		var el = $( this.tagSelector );  
		
		if( el.length ){
  		
  		this.isChecking = 1;
		
			$( this.tagSelector ).first().each( function(){
			
				var el = $( this );
				
				var product = $( this ).closest( __this.productSelector );
				
				__this.tag = el;
				
				var currTag = el.attr( __this.relatedTag ).replace( /\ /g, '-' );
				
				var currUrl = __this.base + '/collections/all/' + currTag;
				
				$.ajax({
			        url: currUrl,        
		    })
		    .done(function(data){
			    if(el.closest(__this.productSelector).length>0) 
			      __this.setupRelatedProducts(data, el, 'products');
			    else
		        __this.setupRelatedProducts(data, el, 'product');
		    })
			});
		} 
	}
	
	setupRelatedProducts( data, el, type ) {
		
		var __this=this;
		
    var intVal=parseInt(el.find(this.relatedProductSelector).length-1);	    
    var intLabel=el.closest(this.productSelector).find(this.titleSelector).text();
    
    var tag=__this.tag.attr(this.relatedTag);
    
    var productMeta=$(this.productFormSelector+' [data-related="'+tag+'"]');
    
    if(type=='products') productMeta=$(this.collectionSelector+' [data-related="'+tag+'"]');
    
    var products = productMeta.closest( this.productFormSelector );
    if( type == 'products' ) products = productMeta.closest( this.productSelector );
    
    if( intVal ){
	    	
	    var source = $( '#colorTemplate' ).html();
      var template = Handlebars.compile( source );
      
      var colors = [];
	   
    	$(data).find(this.relatedProductSelector).each( function(){
	    	
    	  var link = $( this ).find( 'a' ).first( ).attr( 'href' );
    	  var swatch = '';
    	  var color = '';
    	  
    	  if( typeof $( this ).find( '[data-color]' ).attr( 'data-color' ) != 'undefined' ) { 
    	    color = $( this ).find( '[data-color]' ).attr( 'data-color' ).replace( 'color:', '' );
    	  }
    	  
    	  if( typeof $( this ).find( '[data-swatch]' ).attr( 'data-swatch' ) != 'undefined' ) {
	    	  
	    	  var int = $( this ).find( '[data-swatch]' ).attr( 'data-swatch' ).replace( 'swatch:', '' );
	    	  
	    	  if( int.indexOf( '#' ) > -1 ) swatch = int;
	    	  if( int.indexOf( '.' ) > -1 ) swatch = 'url(' + int + ')';
	    	  
	    	 }
    	  
    	  var name = color != '' ? color : $( this ).find( __this.titleSelector ).text();
    	  
    	  colors.push( {
	    	  
	    	  link: link,
	    	  swatch: swatch,
	    	  name: name
	    	  
    	  } )
          
      } )
        
      var context={ "colors": colors };
      
      var html=template(context);
      products.find('.more-colors').html(html); 
		    	
	  }
    
    productMeta.each( function(){ 
	    
	      $( this ).attr( 'data-completed', '1' ); 
	      
	    } );
	    
	    $( 'body' )[0].offsetHeight;
	    
      this.isChecking = 0;
    
    __this.runCheck();
    	
	}
	
	setupRelatedProduct() {
		  
		  var __this = this;
		
	}
}

class StockistStick {
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.map=el.find('.map');
    this.timer=null;
    
    $(window).on('resize, retrigger load', function(){
      
      clearTimeout(__this.timer);
      __this.timer=setTimeout(function(){__this.setupHeight();}, 100);
    }), this.setupHeight();
    
    $(window).on('scroll', function(){
      __this.runScroll();
    }), this.runScroll();
  }
  setupHeight(){
    var __this=this;
    
    this.windowHeight=$(window).height();
    this.mapHeight=this.map.height();
    this.runScroll();
    
  }
  runScroll(){
    var __this=this;
    
    this.scrollPos=$(window).scrollTop();
    this.fixTop=this.windowHeight-this.mapHeight;
    this.elTop=this.el.offset().top;
    this.elPos=this.elTop-this.scrollPos;
    
    if(this.fixTop<this.elPos){
      
      this.map
        .addClass('fixed')
        .css('top', this.fixTop)
        .css('left', this.el.offset().left)
    }else{
      this.map
        .removeClass('fixed')
        .css('top', '0')
        .css('left', 'auto')
        .css('right', 'auto');
    }
  }
}

class StockistModal {
  
  constructor(btn){
    
    var __this=this;
    
    this.btn=btn;
    this.modal=$('#stockists-modal-new');
    this.container=this.modal.find('.inner');
    this.close=this.modal.find('[href="/close"]');
    this.btn.on( 'click', function(e){
      
      e.preventDefault();
      __this.container.data('modal', new Stockists(__this.container));
      __this.modal.addClass('reveal');
      
    } )
    this.close.on('click', function(e){
      e.preventDefault();
      __this.modal
        .removeClass('reveal')
        .addClass('unreveal');
        
        setTimeout(function(){ __this.modal.removeClass('unreveal'); }, 1000);
    }) 
  }
}

class SectionScroll {
  constructor(el){
    var __this=this;
    this.base=el;
    this.distance=350;
    this.scrollDistance=parseFloat($('body').attr('data-scroll-distance'));
    this.hasScrolled=0;
    
    this.el=this.base.find(this.base.attr('data-section-scroll')).first();
    $(window).on('resize', function(){
      __this.setupLimits()
    })
    $(window).on('scroll', function(){
      __this.runScroll();
    })
    this.setupLimits();
    this.runScroll();
  }
  setupLimits(){
    this.elHeight=this.base.outerHeight()
    this.top=this.base.offset().top;
    this.bottom=this.top+this.elHeight;
    
  }
  runScroll(){
    var scrollTop=$(window).scrollTop();
    var scrollBottom=scrollTop+$(window).height();
    console.log(scrollTop, this.scrollDistance);
    if(scrollTop>this.scrollDistance){
      if(! this.hasScrolled) $('body').attr('data-has-scrolled', 1);
      $('body').attr('data-is-scrolled', 1);
    }else{
      $('body').removeAttr('data-is-scrolled');
    }
    
    var pos=0;
    
    if(scrollBottom<this.top) pos=-this.distance/2;
    else if(scrollTop>this.bottom) pos=this.distance/2;
    else {
      var overflow=scrollBottom-this.top;
      var offset=overflow/(this.elHeight*2);
      var distance=(offset*this.distance)-(this.distance/2);
      this.el.css('transform', 'translateY('+distance+'px)');
    }
  }
}

class MobileCheck {
  constructor(){
    var __this = this;
    $(window).resize(function(){
      __this.runCheck();
    })
    this.runCheck();
  }
  
  runCheck(){
    if($('#isMobile').is(':visible')){
      isMobile=1;
    }else{
      isMobile=0;
    }
  }
}
class BundleOverlay {
  constructor(el){
    var __this=this;
    this.el=el;
    this.inner='.bundle-overlay--inner';
    
    this.el.on('click', function(e){
      if(isMobile) {
        __this.runMobileClick(e);
      }
    })
  }  
  runMobileClick(e) {
    var el=$(e.target);
    if(this.el.is('.hover')) {
      if(!el.closest(this.inner).length) this.el.removeClass('hover');
    }else {
      this.el.addClass('hover');
    }
  }
}
class Bundle{
  
  constructor(el){
    
    var __this=this;
    
    this.el=el;
    this.item=this.el.find('.bundle-item');
    this.btn=el.find('.add-bundle');
    this.btnRef=el.find('.view-rel, [href="/close"]');
    this.close=el.find('[href="/close"]');
    
    this.setupBundle();
    this.btn.on('click', function(e){
      e.preventDefault();
      if(!__this.getFirstVariant()) {
        console.log('not getting var');
      }else{
        //__this.btn.attr('disabled', 'disabled');
        __this.btn.attr('adding', 'adding')
        __this.addBundle();
      }
    });
    this.btnRef.on('click', function(e){
      e.preventDefault();
      var parent=$(this).closest('.bundle-overlay--inner');
      parent.removeClass('active');
      if(__this.el.is('.active')) __this.el.removeClass('active')
      else{
        __this.el.addClass('active');
        parent.addClass('active');
      }
    });
  }
  
  setupBundle(){
    
    var __this=this;
    
    this.item.each(function(){
      $.data($(this), 'bundleItem', new BundleItem($(this), __this));
    });
    
  }
  
  testBundle(){
    
    if(!this.el.find('.product-option:not([data-option])').length){
      this.el.addClass('can-add');
    }
  }
  
  addBundle(){
    var __this=this;
    let data={};
    let variant=this.getFirstVariant();
    variant.attr('data-complete', 'complete');
    data['quantity']=1;
    data['id']=variant.attr('data-variant');
    
    this.updateCart({
      type: 'POST',
      url: theme.routes.cartAdd,
      data: data,
      dataType: 'json'
    }).then(function() {
      
      if(!__this.getFirstVariant()){  
        $('body').trigger('added.ajaxProduct');
        $('body').attr('data-cart-active',1);
        __this.el.find('.variants').each(function(){
          $(this).removeAttr('data-complete');
        })
        __this.btn.removeAttr('adding');
      }else {
        __this.addBundle();
      }
    });

  }
  getFirstVariant(){
    var variants=this.el.find('.variants[data-variant]:not([data-complete])');
    if(variants.length) return variants.first();
    else return 0;
    
  }
  updateCart(params) {
    return $.ajax(params)
      .then(function(cart) {
        return cart;
      }.bind(this))
  }
}

class BundleItem{
  
  constructor(el, root){
     
    var __this=this;
    
    this.el=el;
    this.block=this.el.closest('.bundle-block');
    this.banner=this.block.find('.bundle-banner');
    this.root=root; 
    this.options=this.el.find('.product-option');
    this.span=this.options.find('span');
    this.variant=this.el.find('.variants');
    this.variants=this.el.find('.variants label');
    
    this.options.each(function(){
      $.data($(this), 'bundleOption', new BundleOption($(this), __this));
    });
    
  }
  
  runSpan(){
    
    var __this=this;
    
    if(!this.el.find('.product-option:not([data-option])').length){
      
      var intStr='';
      this.el.find('.product-option[data-option]').each(function(index){
        if(index>0) intStr+=' / ';
        intStr+=$.trim($(this).attr('data-option'));
      });
      
      console.log(intStr+' testing');
      
      this.selectVariant(intStr);
    }
  }
  
  selectVariant(str){
    
    var __this=this;
    
    this.variants.each(function(){
      var compare=$(this).text();
      var indexArray=[];
      //console.log(str+'    '+compare);
      if(compare==str){
        __this.variant.attr('data-variant', $(this).attr('value'));
      }
    });
    
    this.root.testBundle();
  }
}

class BundleOption {
  
  constructor(el, root){
    var __this=this;
    this.el=el;
    this.root=root;
    this.span=this.el.find('span');

    if(this.span.length==1){
      this.span.first().each(function(){
        if($(this).is('.avail--true')){ 
          $(this).addClass('active');
          //__this.el.attr('data-option', $(this).text());
          __this.el.attr('data-option', $(this).attr('value'));
        }else {
          $(this).closest('.options').find('span').each(function(){
            $(this)
              .removeClass('avail--true')
              .addClass('avail--false');
          })
        }
      });
    } else {
      this.span.on('click', function(){
        if($(this).is('.avail--true')){
          $(this).addClass('active')
            .siblings().removeClass('active');
          
          //__this.el.attr('data-option', $(this).text());
          __this.el.attr('data-option', $(this).attr('value'));
          __this.root.runSpan($(this));
        }
      });
    }
  }
}
class PageScroll{
  
  constructor(el){
    
    var __this=this;
    this.scrollDistance=parseFloat($('body').attr('data-scroll-distance'));
    
    $(window).scroll(function(){
      __this.checkVisibility();
    });
    
    $('body').on('reinit', function(){
      __this.getBounds();
      __this.checkVisibility();
    })
  }
  
  checkVisibility(){  
    if(scrollTop>this.scrollDistance){
      if(! this.hasScrolled) $('body').attr('data-has-scrolled', 1);
      $('body').attr('data-is-scrolled', 1);
    }else{
      $('body').removeAttr('data-is-scrolled');
    }
  }
}
class ElementVisibility {
  
  constructor(el){
    
    var __this=this;
    this.el=el;
    this.wait=1500;
    
    this.getBounds();
    
    $(window).resize(function(){
      __this.getBounds();
    })
    $(window).on('retrigger', function(){
      __this.getBounds();
    })
    
    $(window).scroll(function(){
      __this.checkVisibility();
    });
    
    $('body').on('reinit', function(){
      __this.getBounds();
      __this.checkVisibility();
    })
    
    this.checkVisibility();
  }
  
  getBounds(){
    var __this=this;
    this.top=this.el.offset().top;
    this.elHeight=this.el.outerHeight();
    this.bottom=this.top+this.elHeight;
  }
  
  checkVisibility(){
    var intProp=0;
    
    if(scrollBottom<this.top){
      this.el.removeAttr('data-visible');
    }else if(scrollTop>this.bottom){
      this.el.removeAttr('data-visible');
      intProp=2;
    }else{
      this.el.attr('data-init', 1);
      this.el.attr('data-visible', 1);
      intProp=((scrollBottom-this.top)/(this.elHeight+$(window).height())).toFixed(3);
      intProp=intProp*2;
      
    }
    intProp=intProp-1;
    this.el.attr('data-prop', intProp);
  }
}

class CarouselInstagram{
  
  constructor(el){
    
    var __this=this;
    this.el=el;
    this.cont=this.el.find('.carousel-ig');
    this.boxClass='.carousel-ig--box';
    this.box=this.el.find(this.boxClass);
    this.itemClass=this.el.find('.carousel-ig--item');
    this.attempts=10;
    this.wait=1500;
    this.distance=.5;
    this.interval=null;
    this.imgClass='.fs-entry-container';
    this.currPos=0;
    this.prevScroll=$(window).scrollTop();
    
    this.direction=this.el.is('.carousel-ig--reversed')? 1 : 0;
    
    this.testAvailable();
  }
  testAvailable(){
    var __this=this;
    this.img=this.el.closest('.shopify-section').find(this.imgClass);
    
    if(this.img.length){
      this.runSetup();
    }else{
      this.setSetTimeout();
    }
  }
  
  setSetTimeout(){
    var __this=this;
    setTimeout(function(){ __this.testAvailable(); }, this.wait);
  }
  
  runSetup(){
    
    var __this=this;
    
    this.boxClone=this.box.clone();
    this.boxClone.appendTo(this.box.parent());
    this.boxClone[0].offsetHeight;
    this.el.find(this.boxClass).each(function(ind){
      var intItems=$(this).find('>*');
      __this.img.each(function(index){
        var intEl=$(this).clone();
        var intItem=intItems.eq(index);
        intItem.attr('data-complete', 1);
        intEl.appendTo(intItem.find('> div'));
        intEl.data('rel', $(this));
        intEl.on('click', function(){
          $(this).data('rel').find('.fs-timeline-entry').trigger('click')
        })
        $.data(intEl, 'CarouselInstagramImage', new CarouselInstagramImage(intEl));
      });  
    })
    
    //this.currPos=Math.round(Math.random()*this.box.find('>*').last().position().left);

    if(this.direction) this.currPos=-1*this.currPos;
    
    this.box.find('.carousel-ig--item:not([data-complete])').remove();
    
    $(window).on('scroll', function(){
      __this.testVisible();
    });
    
    $(window).resize(function(){
      __this.runPosition();
    });
    
        
    this.testVisible()
    this.runPosition();
    
  }
  
  testVisible(){
    
    var __this=this;
    
    if(__this.cont.is('[data-visible]')){
      if(__this.interval==null) __this.interval=setInterval( function(){ __this.runSection() }, 36 );
    } else {
      if(__this.interval!=null){
        clearInterval(__this.interval);
        __this.interval=null;
      }
    }
  }
  
  runPosition(){
    var __this=this;
    
    var intEl=this.box.find('>*').last();
    
    this.box.find('>*').each(function(){  });
    this.offset=intEl.position().left+intEl.outerWidth();

    if(this.direction){
      this.boxClone.css('left', -this.offset);
    }else{
      this.boxClone.css('left', this.offset);
    }
  }
  
  runSection(){
  
    var __this=this;
    
    var currScroll=$(window).scrollTop();
    var extra=Math.abs(currScroll-this.prevScroll)/12;
    var newPos=this.currPos-extra-this.distance;
    
    var overflow=newPos+this.offset;
    
    newPos=overflow<0 ? overflow:newPos;
    newPos=newPos.toFixed(3);
    
    if(this.direction){
      var intPos=-newPos;
      this.cont.css('transform', 'translate('+intPos+'px, 0)');  
    }else{
      this.cont.css('transform', 'translate('+newPos+'px, 0)');
    }
    
    this.prevScroll=currScroll;
    this.currPos=newPos;
    
  }
}

class CarouselInstagramImage{
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.rel=this.el.data('rel');
    this.imgClass='.fs-timeline-entry';
    this.bgImg=null;
    this.wait=2000;
    this.testAvailable();
  }
  
  testAvailable(){
    
    var __this=this;
    
    var style=this.rel.find(this.imgClass).attr('style');
    
    if(typeof style=='undefined'){
      this.setSetTimeout();
    }else{
      if(style.indexOf('background-image')>-1){
        this.runSetup(style);
      }else{
        this.setSetTimeout();
      }
    }
  }
  
  runSetup(style){
    
    var __this=this;
    var intEl=this.el.find(this.imgClass);
    intEl.attr('style', style)
    intEl[0].offsetHeight;
    intEl.removeClass('fs-loading');
    
  }
  
  setSetTimeout(){
    var __this=this;
    setTimeout(function(){ __this.testAvailable(); }, this.wait);
  }
}

class ArticleBanner {
  constructor(el){
    var __this=this;
    this.el=el;
    this.fix=this.el.find('.fix'); //console.log(this.fix.length+' fixlen');
    this.spacer=this.el.find('.spacer');
    
    this.initBanner();
    $(window).on('resize', function(){
      __this.initBanner();
    })
    $(window).on('scroll', function(){
      __this.runScroll();
    })
  }
  runScroll(){
    if(typeof this.el.attr('data-prop')=='undefined') return;
    var prop=1.5-(1.5*this.el.attr('data-prop'))
    prop=prop>1?1:prop;
    this.fix.css('opacity', prop);
  }
  initBanner(){
    var __this=this;
    this.fix.addClass('fixed')
    this.spacer.height(this.fix.outerHeight());
  }
}

class ArticleGallery{
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.swiperEl=this.el.find('.swiper');
    this.display=this.el.find('.display');
    this.fix=this.el.find('.fix'); //console.log(this.fix.length+' fixlen');
    this.spacer=this.el.find('.spacer');
    this.next=this.el.find('.next');
    this.prev=this.el.find('.prev');
    this.cnt=this.el.find('.swiper-slide').length;
    this.initGallery();
    setTimeout(function(){ __this.updateIndex(); }, 500);
    this.initBanner();
    $(window).on('resize', function(){
      __this.initBanner();
    })
  }
  initBanner(){
    var __this=this;
    this.fix.addClass('fixed')
    this.spacer.height(this.fix.outerHeight());
  }
  initGallery(){
    var __this=this;
    this.swiper=new Swiper(this.swiperEl[0], {
      // Default parameters
      slidesPerView: 'auto', 
      loop: true
      // Responsive breakpoints
    })
    this.slide=this.el.find('.swiper-slide');
    
    this.next.on('click', function(){
      __this.swiper.slideNext();
      __this.updateIndex();
    })
    this.prev.on('click', function(){
      __this.swiper.slidePrev();
      __this.updateIndex();
    })
    this.swiper.on('touchEnd', function(){
      setTimeout(function(){ __this.updateIndex(); }, 150);
    })
  }
  updateIndex(){
    
    var __this=this;
    var rightVal=Math.abs(this.swiper.translate)+$(window).width();
    var active=this.el.find('.swiper-slide-active');
    var activeVal=parseInt(active.attr('data-swiper-slide-index'))+1;
    var activeStr=activeVal+'';
    
    active.nextAll().each(function(){
      var elLeft=$(this).position().left;
      var intVal=parseInt($(this).attr('data-swiper-slide-index'))+1;
      if(elLeft<rightVal){
        activeStr+=', '+intVal;
      }
    })
    this.display.text('displaying '+activeStr+ ' | '+this.cnt+' images');
    //console.log('displaying '+activeStr+ ' | '+this.cnt+' images');
  }
}

class MuseH2 {
  
  constructor(el) {
  
    var __this=this;
    
    this.el=el;
    this.base=this.el.closest('.cc-featured-muse');
    this.content=this.base.find('.article-block__content');
    
    this.flex=this.el.find('> *').first();
    this.block=this.flex.find('> *').first();
    
    this.blockWidth=0;
    this.prevScroll=$(window).scrollTop();
    this.currPos=0;
    this.distance=.25;
    
    this.setupSection();
    
    $(window).on('scroll', function(){
      __this.runScroll();
    });
    $('body').on('reCalculate', function(){
      setTimeout(function(){ __this.runScroll(); }, 150);
    });
    this.runScroll();
  }
  
  runScroll(){
    if(typeof this.base=='undefined') return;
    var prop=this.base.attr('data-prop');
    var val=prop*100;
    this.content.css('transform', 'translateY('+val+'px)');
  }
  
  setupSection(){
    
    var __this=this;
    
    this.blockWidth=this.block.first().outerWidth();
    this.interval=setInterval(function(){ __this.runSection() }, 25);
  }
  
  runSection (){
    
    var __this = this;
    
    var currScroll=$(window).scrollTop();
    var extra=Math.abs(currScroll-this.prevScroll)/12;
    var newPos=this.currPos-extra-this.distance;
    var overflow=newPos+this.block.first().outerWidth();
    newPos=overflow< 0?overflow:newPos;
    this.flex.css('transform', 'translate('+newPos+'px, 0)');
    
    this.prevScroll=currScroll;
    this.currPos=newPos;
  }
}

class MuseBlock{ // sets min heights
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.block=this.el.find('.muse-banner .grid > div:visible').last();
    
    $(window).on('resize', function(){
      __this.setHeight(); 
    })
    this.el.find('img').each(function(){
      
      if($(this)[0].complete){
        __this.setLoadClass($(this));
      }else{
        $(this).on('load', function(){
          __this.setLoadClass($(this));
          __this.setHeight();
        })
      }
    })
    this.setHeight();
  }
  setLoadClass(el){
    $('body').trigger('reinit');
    el.closest('.muse--image').addClass('loaded');  
  }
  setHeight(){
    var __this=this;
    if(!this.block.length) return;
    var elHeight=this.block.position().top+this.block.outerHeight();
    this.el.css('min-height', elHeight+'px');
    $('body').trigger('reCalculate');
  }
}

class MuseProducts {

  constructor(el) {
    var __this=this;
    this.el=el;
    this.swiperEl=this.el.find('.swiper');
    this.next=this.el.find('[href="#next"]');
    this.prev=this.el.find('[href="#prev"]');
    this.display=this.el.find('.display');
    this.slidesInView=2;
    this.initGallery();
  }
  
  initGallery(){
    var __this=this;
    this.swiper=new Swiper(this.swiperEl[0], {
      // Default parameters
      slidesPerView: 2, 
      loop: true, 
      // Responsive breakpoints
      on: {
        init: function init() {
          
          lazySizes.autoSizer.checkElems();
          
          var firstIndex=this.activeIndex+1;
          var lastIndex=firstIndex+__this.slidesInView-1;
          var text=firstIndex+' – '+lastIndex+' of '+__this.el.find( '.swiper-slide' ).length;
          __this.display.text(text)
          
        },
        activeIndexChange: function(){
          
          var firstIndex=this.activeIndex;
          var lastIndex=firstIndex+__this.slidesInView-1;
          var text=firstIndex+' – '+lastIndex+' of '+__this.el.find( '.swiper-slide' ).length;
          __this.display.text(text)
        }
      }
    })
    
    this.slide=this.el.find('.swiper-slide');
    
      this.next.on('click', function(e){
        e.preventDefault();
        __this.swiper.slideNext();
        //__this.updateIndex();
      })
    
      this.prev.on('click', function(){
        __this.swiper.slidePrev();
        //__this.updateIndex();
      })
      /*
      this.swiper.on('touchEnd', function(){
        setTimeout(function(){ __this.updateIndex(); }, 150);
      })
      */
    }
    updateIndex(){
      
      var __this=this;
      var rightVal=Math.abs(this.swiper.translate)+$(window).width();
      var active=this.el.find('.swiper-slide-active');
      var activeVal=parseInt(active.attr('data-swiper-slide-index'))+1;
      var activeStr=activeVal+'';
      
      active.nextAll().each(function(){
        var elLeft=$(this).position().left;
        var intVal=parseInt($(this).attr('data-swiper-slide-index'))+1;
        if(elLeft<rightVal){
          activeStr+=', '+intVal;
        }
      })
      this.display.text('displaying '+activeStr+ ' | '+this.cnt+' images');
      //console.log('displaying '+activeStr+ ' | '+this.cnt+' images');
    }
}

class MuseFeatured {

  constructor(el) {
    var __this=this;
    this.el=el;
    this.init=0;
    this.block=this.el.find('.article-block--meta');
    this.slide=this.el.find('.muse--image.muse--image__flex');
    $(window).on('resize', function(){
      __this.setMin();
    });
    this.setMin();
    this.setClass();
  }
  setMin(){
    var __this=this;
    var height=this.block.position().top+this.block.outerHeight()+this.block.parent().position().top;
    this.el.height(height);
    this.slide.height(height);
  }
  setClass(){
    var __this=this;
    this.slide.each(function(){
      var el=$(this).find('img').first();
      if(el[0].complete) $(this).addClass('loaded');
      else {
        el.on('load', function(){
          $(this).addClass('loaded');
        });
      }
    });
  }
}

class AnnouncementSlider {

  constructor(el) {
    var __this=this;
    this.el=el;
    this.block=this.el.find('> div').first();
    this.duration=2500;
    this.init=0;
    this.calcOffset()
    $(window).on('resize', function(){ __this.calcOffset(); });
    
    this.runSlider();
  }
  
  calcOffset(){
    this.distance=-1*this.block.outerWidth();
    this.el.css('transition', 'transform '+this.duration+'ms linear');
  }
  
  runSlider(){
    var __this=this;
    this.calcOffset();
    
    this.el.css('transition-duration', '0ms');
    this.el.css('transform', 'translateX(0)');
    this.el[0].offsetHeight;
    this.el.css('transition-duration', this.duration+'ms');
    this.el.css('transform', 'translateX('+this.distance+'px)');
    this.init=1;
    setTimeout(function(){ __this.runSlider(); }, this.duration);
  }
}

class AnnouncementMulti {
  
  constructor(el) {
    var __this=this;
    this.el=el;
    this.duration=4000;
    this.block=this.el.find('> div > div');
    this.cnt=1;
    this.runBlock();
  }
  
  runBlock(){
    var __this=this;
    var active=this.cnt%this.block.length;
    this.block.eq(active).addClass('active').siblings().removeClass('active');
    this.cnt++;
    
    setTimeout(function(){ __this.runBlock(); }, __this.duration);
  }
}

class MobileMenuItem {
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.close=this.el.parent().closest('.has-children').first();
    this.a=this.el.find('a').first();
    this.ul=this.el.find('ul').first();
    this.allA=this.ul.find('> li > a');
    this.allUl=this.ul.find('> li > ul');
    this.activeUl='> li.has-children.active > ul';
    this.lastEl=this.ul.find('> li').last();
    
    this.a.on('click', function(e){
      var el=$(e.target);
      __this.runClick(e, el);
    })
  }
  
  runClick(e, el){
    var __this=this;
    if(el.find('> .arr').length || el.closest('.arr').length) {
      e.preventDefault();
      var height=0;
      if(!this.el.is('.active')) {
        //height=this.lastEl.offset().top-this.lastEl.parent().offset().top+this.lastEl.outerHeight();
        height=this.countAll(this.allA);
        height+=this.countAll(this.ul.find(this.activeUl));
        this.ul.attr('data-height', height);
        this.el.addClass('active')
      }else {
        this.el.removeClass('active');
      }
      this.el[0].offsetHeight;
      this.ul.height(height);
      this.close.each(function(){
        $(this).data('MobileMenuItem').updateHeight(e, el);
      })
    }
  }
  
  updateHeight(){
    var height=0;
    height=this.countAll(this.allA);
    height+=this.countAll(this.ul.find(this.activeUl));
    this.el[0].offsetHeight;
    this.ul.height(height);
    this.close.each(function(){
      $(this).data('MobileMenuItem').updateHeight(e, el);
    })
  }
  
  countAll(el){
    var height=0;
    el.each(function(){
      if(typeof $(this).attr('data-height')!='undefined') height+=parseInt($(this).attr('data-height'));
      else height+=$(this).outerHeight();
    })
    return height;
  }
}

class BannerH2 {
  
  constructor(el) {
  
    var __this=this;
    
    this.el=el;
    this.base=this.el.closest('.cc-featured-muse');
    this.content=this.base.find('.article-block__content');
    
    this.flex=this.el.find('> *').first();
    this.block=this.flex.find('> *').first();
    
    this.blockWidth=0;
    this.prevScroll=$(window).scrollTop();
    this.currPos=0;
    this.distance=.25;
    
    this.setupSection();
    
    $(window).on('scroll', function(){
      __this.runScroll();
    });
    $('body').on('reCalculate', function(){
      setTimeout(function(){ __this.runScroll(); }, 150);
    });
    this.runScroll();
  }
  
  runScroll(){
    if(typeof this.base=='undefined') return;
    var prop=this.base.attr('data-prop');
    var val=prop*100;
    this.content.css('transform', 'translateY('+val+'px)');
  }
  
  setupSection(){
    
    var __this=this;
    
    this.blockWidth=this.block.first().outerWidth();
    this.interval=setInterval(function(){ __this.runSection() }, 25);
  }
  
  runSection (){
    
    var __this = this;
    
    var currScroll=$(window).scrollTop();
    var extra=Math.abs(currScroll-this.prevScroll)/12;
    var newPos=this.currPos-extra-this.distance;
    var overflow=newPos+this.block.first().outerWidth();
    newPos=overflow< 0?overflow:newPos;
    this.flex.css('transform', 'translate('+newPos+'px, 0)');
    
    this.prevScroll=currScroll;
    this.currPos=newPos;
  }
}

class SizeChart {
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.box=this.el.find('.size-chart--content');
    this.tables=this.el.find('table');
    this.td=this.el.find('td, th');
    this.tdTimer=null;
    this.tabs=this.el.find('.tab');
    this.nav=this.el.find('.chart--nav li');
    this.values=this.el.find('.chart--values li');
    this.btn=$('[href*="#size-chart"]');
    this.modal=this.el.closest('.theme-modal');
    if(this.modal.length) this.close=this.modal.find('[href="#close"]');
    this.values.on('click', function(){
      $(this).addClass('active')
        .siblings().removeClass('active');
        
      var value=$(this).attr('data-value');
      __this.tables.each(function(){
        $(this).attr('data-value', value);
      })
    });
    this.nav.on('click', function(){
      var index=$(this).index();
      $(this).addClass('active')
        .siblings().removeClass('active');
      __this.tabs.eq(index).each(function(){
        $(this).show();
        $(this)[0].offsetHeight;
        $(this).addClass('active')
      })
      __this.tabs.eq(index).siblings().each(function(){
       $(this).removeClass('active'); 
       setTimeout(function(){ $(this).hide(); }, 500);
      });
        
      setTimeout(function(){ __this.setWindowHeight(); },100);
    });
    this.setWindowHeight();
    $(window).on('load resize', function(){
      __this.setWindowHeight();
    })
    if(!this.btn.length) return;
    this.btn.on('click', function(e){
      e.preventDefault();
      var el=__this.el.closest('.theme-modal');
      el.removeClass('unreveal');
      el[0].offsetHeight;
      el.addClass('reveal');
    })
    this.close.on('click', function(e){
      e.preventDefault();
      __this.modal.removeClass('reveal');
      __this.modal.addClass('unreveal');
    });
    this.setupTD();
  }
  setupTD(){
    var __this=this;
    this.td.hover(function(){
      clearTimeout(__this.tdTimer);
      var index=$(this).index();
      var table=$(this).closest('table');
      var tr=$(this).closest('tr');
      tr.find('td, th').addClass('active')
        .siblings().find('td, th').removeClass('active')
      tr.siblings().each(function(){
        $(this).find('td, th').eq(index).addClass('active')
          .siblings().removeClass('active');
      })
        
    }, function(){
      __this.tdTimer=setTimeout(function(){ __this.clearTD(); }, 100)
    })
  }
  clearTD(){
    this.td.each(function(){
      $(this).removeClass('active');
    })
  }
  setWindowHeight(){
    var __this=this;
    var height=0;
    this.tabs.each(function(){
      //height=$(this).height()>height?$(this).height():height;
      if($(this).is('.active')){
        height=$(this).outerHeight();
      }
    })
    if(height) this.box.height(height);
  }
  /*
  setWindowHeight(){
    var __this=this;
    var height=0;
    this.tabs.each(function(){
      height=$(this).height()>height?$(this).height():height;
    })
    this.box.height(height);
  }
  */
}

class ArticleImages {
  constructor(){
    var __this=this;
    this.setupImages()
  }
  setupImages(){
    
    $('.no-side-pad').each(function(){
      var first=$(this)
      var elArr=[$(this)];
      var cont=1;
      if($(this).parent().is('.post--flex')) return;
      else {
        $(this).nextAll().each(function(){
          if($(this).is('.no-side-pad')&&cont) elArr.push($(this));
          else cont=0;
        })
        if(elArr.length>1){
          var div=$('<div class="post--flex"></div>')
          div.insertBefore(first)
          $.each(elArr, function(index, el){
            div.append(el);
          });
          var total=0;
          $.data(div, 'ArticleRow', new ArticleRow(div));
        }
      }
    })
  }
}

class ArticleRow {
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.completed=0;
    this.el.find('img').each(function(){
      $(this).attr('data-waiting', '1');
      if(this.complete) __this.nextImg($(this));
      else{
        $(this).on('load', function(){
          __this.nextImg($(this));
        })
      }
    })
  }
  nextImg(el){
    var __this=this;
    el.attr('data-width', el.width());
    el.attr('data-height', el.height());
    el.attr('data-aspect', el.width()/el.height());
    el.removeAttr('data-waiting');
    this.checkAll();
  }
  checkAll(){
    if(!this.el.find('[data-waiting]').length&&!this.completed) this.runWidth();
  }
  runWidth(){
    var __this=this;
    this.total=0;
    this.el.find('img').each(function(){
      __this.total+=parseFloat($(this).attr('data-aspect'));
    })
    if(this.total>0) {
      this.completed=1;
      this.el.find('img').each(function(){
        var prop=parseFloat($(this).attr('data-aspect'))*100/__this.total;
        $(this).attr('data-width', prop);
        $(this).parent().width(prop+'%');
      })
    }
  }
}
class AnchorBlock {
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.a=this.el.find('ul li');
    this.btn=this.el.find('.btn');
    this.init();
    this.runPos();
    $(window).on('load resize', function(){
      __this.init();
      __this.runPos();
    })
    $(window).on('scroll', function(){
      __this.runPos();
    })
    this.btn.on('click', function(){
      //$(window).scrollTop(0);
      $('html, body').animate({ scrollTop: 0 });
    })
    this.a.on('click', function(){
      //$(window).scrollTop(parseFloat($(this).attr('data-top')));
      $('html, body').animate({ scrollTop: $(this).attr('data-top') });
    })
  }
  init(){
    var prev=null;
    this.a.each(function(){
      var relTerm=$.trim($(this).attr('data-anchor'));
      var relEl=$('[data-anchorpoint="'+relTerm+'"]').first();
      if(!relEl.length){
        $(this).css('border', '10px solid red');
        return;
      }
      $(this).attr('data-top', relEl.offset().top);
      prev=$(this);
    })
  }
  runPos(){
    var __this=this;
    var scrollMid=(scrollTop+scrollBottom)/2;
    this.a.each(function(){
      if(scrollMid>parseFloat($(this).attr('data-top'))){
        $(this).addClass('active')
          .siblings().removeClass('active');
      }
    })
  }
}

class ModalToggle {
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.attr='data-new-modal-toggle';
    this.id=this.el.attr(this.attr);
    this.rel=$(this.id);
    this.close='[href="#close"]';
    
    $('body').on('click', function(e){
      __this.runClick(e);
    })
    
  } 
  runClick(e){
    var __this=this;
    var target=$(e.target);
    var hide=0;
    if(target.is('['+this.attr+'="'+this.id+'"]') || target.closest('['+this.attr+'="'+this.id+'"]').length){
      e.preventDefault();
      if(this.rel.is('.reveal')){
        this.rel.removeClass('reveal');
        $('body').removeAttr('data-modal')
      } else {
        this.rel.addClass('reveal');
        setTimeout(function(){ 
          $('body').removeAttr('data-modal-id')
          $('body').attr('data-modal', __this.id); }, 50);
      }
      return;
    }
    
    if(target.is(this.id)||target.closest(this.id).length){
      if(target.is(this.close)||target.closest(this.close).length){
        hide=1;
      }
    }else {
      hide=1;
    }
    if(hide) {
      this.rel.removeClass('reveal');
      $('body').removeAttr('data-modal');
    }
  }
}

class TabHeight {
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.tab=this.el.find('.cc-tabs__tab');
    this.btn=this.el.find('[role="tab"]');
    this.btn.on('click', function(e){
      e.preventDefault();
      __this.setHeight();
    })
    this.setHeight();
    $(window).on('resize', function(){
      __this.setHeight();
    })
    
  }
  
  setHeight(){
    var tab=this.el.find('cc-tabs__tab__panel:not([hidden])').first();
    var height=tab.offsetHeight;
    this.el.height(height);
  }
}
class IntroBlock {
  
  constructor(el) {
    var __this=this;
    this.el=el;
    this.blocks=this.el.find('.intro--grid .block');
    this.timer=null;
    this.wait=2500;
    this.state='inactive';
    
    this.initBlocks();
    this.initOptions();
    this.initScroll();
    
    $(window).on('scroll', function(){
      __this.initOptions();
      __this.initScroll();
    })
  }
  initOptions(){
    var __this=this;
    this.elTop=this.el.offset().top;
    this.elBottom=this.elTop+this.el.height();
  }
  initBlocks(){
    var __this=this;
    this.blocks.each(function(){
      $(this).data('intro-block', new IntroBlockBlock($(this), __this));
    })
  }
  initScroll(){
    var __this=this;
    
    if(scrollTop<this.elTop||scrollTop>this.elBottom){ 
      if(this.state=='active') {
        clearTimeout(this.timer);
        this.state='inactive';
        this.timer=setTimeout(function(){ __this.runAnimation(0); }, this.wait);
      }
    } else { 
      if(this.state=='inactive') {
        console.log('doing something?');
        clearTimeout(this.timer);
        this.state='active';
        this.timer=setTimeout(function(){ __this.runAnimation(1); }, this.wait);
      }
    }
  }
  runAnimation(mode) {
    var __this=this;
    this.blocks.each(function(){
      $(this).data('intro-block').runState(mode);
    })
  }
}
class IntroBlockBlock {
  
  constructor(el, root, mode){
    var __this=this;
    this.root=root;
    this.el=el;
    this.timer=null;
    this.parent=this.el.closest('.shopify-section');
    this.rel=this.parent.find('.flexible-layout [data-rel="'+this.el.attr('data-rel')+'"]');
    this.mode=0;
    
    if(!this.rel) return;
    
    this.setLimits();
    this.setInit();
    
    this.proxy=$('<div class="spotlight--proxy"></div>');
    var baseImg=this.el.find('img');
    var newImg=$('<img class=""></img>');
    newImg
      .attr('src', baseImg.attr('data-proxy-src'))
      .attr('style', baseImg.attr('style'))
      .appendTo(this.proxy);
      
    newImg.on('load', function(){
      $(this).addClass('lazyloaded')
    })
      
    console.log(baseImg.attr('data-proxy-src')+'    src');
    this.proxy.appendTo(this.parent);
    
    /*
    $(window).on('resize', function(){ 
      clearTimeout(__this.timer);
      this.timer=setTimeout(function(){ __this.setLimits(); }, 375);
    });
    */
    this.runAnimation();
  }
  setInit(){
    this.tPos=this.t2;
    this.hPos=this.h2;
    this.lPos=this.l2;
    this.wPos=this.w2;
    
    this.la=this.l2;
    this.ta=this.t2;
    this.ha=this.h2;
    this.wa=this.w2;
    
  }
  setLimits(){
    
    this.t1=this.rel.position().top;
    this.h1=this.rel.height();
    this.l1=this.rel.position().left;
    this.w1=this.rel.width();
    
    this.t2=this.el.position().top
    this.h2=this.el.height();
    this.l2=this.el.position().left;
    this.w2=this.el.width();
    
    this.tx=this.t2-this.t1;
    this.hx=this.h2-this.h1;
    this.lx=this.l2-this.l1;
    this.wx=this.w2-this.w1;
  }
  runState(mode) {
    
    this.mode=mode;
    this.setLimits();
  }
  runAnimation(){
    var __this=this;
    
    this.t1=this.rel.position().top;
    this.h1=this.rel.height();
    this.l1=this.rel.position().left;
    this.w1=this.rel.width();
    
    this.t2=this.el.position().top
    this.h2=this.el.height();
    this.l2=this.el.position().left;
    this.w2=this.el.width();
    
    if(this.mode){
      this.la=this.l1;
      this.ta=this.t1;
      this.ha=this.h1;
      this.wa=this.w1;
    }else {
      this.la=this.l2;
      this.ta=this.t2;
      this.ha=this.h2;
      this.wa=this.w2;
    }
    
    var la=(this.lerp(this.lPos, this.la));
    var ta=(this.lerp(this.tPos, this.ta));
    var ha=(this.lerp(this.hPos, this.ha));
    var wa=(this.lerp(this.wPos, this.wa));
    
    this.proxy.css('left', la);
    this.proxy.css('top', ta);
    this.proxy.css('height', ha);
    this.proxy.css('width', wa);
    
    this.lPos=la; 
    this.tPos=ta; 
    this.wPos=wa; 
    this.hPos=ha; 
    
    // console.log(this.lPos, this.tPos, this.wPos, this.hPos);
    
    if(1==1){
      if(Math.abs(this.wPos-this.w2)<1){
        this.proxy.removeClass('active');
        this.el.removeClass('active');
        this.rel.addClass('active');
      }else{
        this.proxy.addClass('active');
        this.el.addClass('active');
        this.rel.removeClass('active');
      }
    }else{
      if(Math.abs(this.wPos-this.w1)<1){
        this.proxy.removeClass('active');
        this.el.removeClass('active');
        this.rel.addClass('active');
      }else{
        this.proxy.addClass('active');
        this.el.addClass('active');
        this.rel.removeClass('active');
      }
    }
    
    window.requestAnimationFrame(function() { __this.runAnimation(); });
  }
  lerp(a, b){
    return(a+((b-a)*.1));
  }
}
class SpotLight {
  constructor(el){
    var __this=this;
    this.el=el;
    this.space=this.el.find('.spacer').first();
    this.wrapper=this.el.find('.spotlight--wrapper');
    this.container=this.el.find('.spotlight--container');
    this.colContainer=this.el.find('.spot-col--container');
    this.block=this.el.find('.spot-col--container .block');
    this.featuredBlock=this.el.find('.spot-col--featured > .block');
    this.content=this.el.find('.banner-columns--content');
    this.hoverElements=this.el.find('.bundle-block');
    this.scrollDistance=this.space.height();
    this.mode=this.el.is('.section-spotlight-about') ? 0 : 1;
    this.animation=0;
    this.featured=[];
    this.alphaPos=0;
    this.token=0;
    this.prop=0;
    this.offsetDistance=this.offsetPos=-50;
    this.direction=1;
    this.complete=0;
    if(this.el.find('.direction-reverse').length) this.direction=0;
    
    this.initOptions();
    this.runScroll();
    this.initBlocks();
    this.initMargins();
    
    if(!this.mode) this.runAnimation();
    else {
      if(!isMobile) this.runAnimation();
    }
    
    $(window).on('scroll', function(){ 
      window.requestAnimationFrame(function() { 
        __this.initOptions();
        __this.runScroll(); 
      })
    })
    $(window).on('resize', function(){ 
      __this.initMargins();
    });
    this.el.find('img').on('load', function(){
      __this.initMargins();
    })
  }
  initMargins(){
    var __this=this;
    var height=this.container.height();
    var colHeight=this.colContainer.height();
    if(colHeight<height) {
      var diff=(colHeight-height)/2;
      this.el.css('margin-top', diff);
    }else{
      this.el.css('margin-top', 0);
    }
  }
  initOptions(){
    var __this=this;
    if(this.direction){
      this.elTop=this.el.offset().top;
      this.elBottom=this.elTop+this.space.height();
      this.wrapper.height(this.container.height());
    }else{
      //this.elTop=this.el.offset().top+this.container.height()-$(window).height();
      this.elTop=this.el.offset().top;
      this.elBottom=this.elTop+this.space.height();
      this.wrapper.height(this.container.height());
    }
    this.veryBottom=this.el.offset().top+this.el.height();
    this.contentBottom=this.veryBottom-this.content.height();
  }
  initBlocks(){
    var __this=this;
    
    this.featuredBlock.each(function(){
      $(this).data('sp-block', new SpotLightBlock($(this), __this));
    })
    
    this.hoverElements.each(function(){
      $(this).hover(function(){
        $('body').attr('data-mode', 'hover');
        __this.el.attr('data-mode', 'hover');
      }, function(){
        $('body').attr('data-mode', 'n/a');
        __this.el.attr('data-mode', 'n/a');
      })
    })
  }
  runScroll(){
    var __this=this;
    
    if(scrollTop<this.elTop){ 
      this.prop=0;
      this.container.attr('data-mode', 'absolute');
    } else if(scrollTop>this.elBottom){ 
      this.prop=1;
      this.container.attr('data-mode', 'static');
    } else {
      this.prop=(scrollTop-this.elTop)/this.scrollDistance;
      this.container.attr('data-mode', 'fixed');
    }
    this.container.attr('data-spot-prop', this.prop);
    
    
    if(scrollTop>this.elBottom && scrollTop<this.veryBottom){
      this.token=1;
      $('body').attr('data-bg-override', 1);
    }else{
      if(this.token){
        this.token=0;
        $('body').attr('data-bg-override', 0);
      }
    }
    
    if(scrollTop<this.elTop) this.content.attr('data-mode-pos', 'start')
    else if(scrollTop>this.contentBottom) this.content.attr('data-mode-pos', 'final')
    else this.content.attr('data-mode-pos', 'stick');
    
    var offset=(-1+this.prop)*this.scrollDistance;
  }
  getProp(){
    return this.prop;
  }
  getDirection(){
    return this.direction;
  }
  runAnimation(){
    var __this=this;
    if(this.direction){
      var alphaPos=(this.lerp(this.alphaPos, this.prop, .05));
      var offsetPos=(this.lerp(this.offsetPos, (this.prop*this.offsetDistance), .05));
    }else {
      var alphaPos=(this.lerp(this.alphaPos, (1-this.prop), .05));
      var offsetPos=(this.lerp(this.offsetPos, (this.prop*this.offsetDistance), .05));
    }
    
    if(!isMobile){
      this.block.each(function(){
        $(this).css('opacity', alphaPos);
        $(this).css('transform', 'translateY('+offsetPos+'px)');
      })
    }else{
      this.block.each(function(){
        $(this).css('opacity', 1);
        $(this).css('transform', 'translateY(0)');
      })
    }
    
    this.alphaPos=alphaPos; 
    this.offsetPos=offsetPos;
    
    setTimeout(function(){ window.requestAnimationFrame(function() { __this.runAnimation(); }), 100 });
  }
  lerp(a, b, speed){
    return(a+((b-a)*speed));
  }
  runComplete(){
    if(this.mode&&!this.complete){
      this.complete=1;
      this.el.attr('data-complete', 'complete');
      var offset=$(window).scrollTop()-this.space.height();
      this.space.height(0);
      $(window).scrollTop(offset);
      setTimeout(function(){ $(window).trigger('retrigger'); }, 100);
    }
  }
}

class SpotLightBlock {
  
  constructor(el, root, mode){
    var __this=this;
    this.root=root;
    this.el=el;
    this.baseEl=this.el.find('')
    this.parent=this.el.closest('.spotlight--container');
    this.featured=this.parent.find('.spot-col--featured');
    this.rel=this.parent.find('.spot-col--container [data-rel="'+this.el.attr('data-rel')+'"]');
    
    if(!this.rel) return;
    
    this.setLimits();
    this.setInit();
    
    this.proxy=$('<div class="spotlight--proxy"></div>');
    var baseImg=this.rel.find('img');
    var newImg=$('<img></img>');
    newImg
      .attr('src', baseImg.attr('data-proxy-src'))
      .attr('style', baseImg.attr('style'))
      .appendTo(this.proxy);
    this.proxy.appendTo(this.parent);
    
    this.runScroll();
    
    /*
    $(window).on('resize', function(){ __this.setLimits(); });
    $(window).on('scroll', function(){ 
       });
       */
    
    this.runAnimation();
  }
  setProp(prop){
    //this.prop=prop;
  }
  setInit(){
    this.tPos=this.t1;
    this.hPos=this.h1;
    this.lPos=this.l1;
    this.wPos=this.w1;
  }
  setLimits(){
    if(this.root.getDirection()){
      this.t1=this.el.position().top;
      this.h1=this.el.height();
      this.l1=this.el.position().left;
      this.w1=this.el.width();
      
      this.t2=this.rel.position().top;
      this.h2=this.rel.height();
      this.l2=this.rel.position().left;
      this.w2=this.rel.width();
    }else {
      
      this.featuredOffset=this.featured.position().top;
      
      this.t1=this.rel.position().top;
      this.h1=this.rel.height();
      this.l1=this.rel.position().left;
      this.w1=this.rel.width();
      
      this.t2=this.el.position().top+this.featuredOffset;
      this.h2=this.el.height();
      this.l2=this.el.position().left;
      this.w2=this.el.width();
    }
    
    this.tx=this.t2-this.t1;
    this.hx=this.h2-this.h1;
    this.lx=this.l2-this.l1;
    this.wx=this.w2-this.w1;
  }
  
  runScroll(){
    
    var proportion=Number(this.parent.attr('data-spot-prop'));
    
    this.la=this.l1+(this.lx*proportion);
    this.ta=this.t1+(this.tx*proportion);
    this.ha=this.h1+(this.hx*proportion);
    this.wa=this.w1+(this.wx*proportion);
    
  }
  runAnimation(){
    var __this=this;
    
    __this.setLimits();
    __this.runScroll();
    
    var la=(this.lerp(this.lPos, this.la));
    var ta=(this.lerp(this.tPos, this.ta));
    var ha=(this.lerp(this.hPos, this.ha));
    var wa=(this.lerp(this.wPos, this.wa));
    
    this.proxy.css('left', la);
    this.proxy.css('top', ta);
    this.proxy.css('height', ha);
    this.proxy.css('width', wa);
    
    this.lPos=la; 
    this.tPos=ta; 
    this.wPos=wa; 
    this.hPos=ha; 
    if(this.root.getDirection()){
      if(Math.abs(this.wPos-this.w2)<1){
        this.proxy.removeClass('active');
        this.el.removeClass('active');
        this.rel.addClass('active');
        this.root.runComplete();
      }else{
        this.proxy.addClass('active');
        this.el.addClass('active');
        this.rel.removeClass('active');
      }
    }else{
      if(Math.abs(this.wPos-this.w1)<1){
        this.proxy.removeClass('active');
        this.el.removeClass('active');
        this.rel.addClass('active');
        this.root.runComplete();
      }else{
        this.proxy.addClass('active');
        this.el.addClass('active');
        this.rel.removeClass('active');
      }
    }
    
    window.requestAnimationFrame(function() { __this.runAnimation(); });
  }
  lerp(a, b){
    return(a+((b-a)*.1));
  }
}

class ShopBanner {
  constructor(el){
    var __this=this;
    this.el=el;
    this.wrapper=this.el.find('.shop-banner--wrapper');
    this.cont=this.el.find('.shop-banner--container');
    this.blocks=this.cont.find('> div');
    this.block=this.blocks.last();
    this.distance=0;
    this.currX=0;
    this.initEl();
    //$(window).on('load', function(){ __this.initEl(); })
    
    $(window).on('resize', function(){ __this.calculateScroll(); })
    $(window).on('scroll', function(){ __this.calculateScroll(); __this.runScroll(); })
    
  }
  initEl(){
    this.initBlocks();
    this.calculateScroll();
    this.runScroll();
    this.runAnimation();
  }
  initBlocks(){
    var __this=this;
    this.bundle=this.el.find('.bundle-overlay');
    this.bundle.each(function(){
      $.data($(this), 'ShopBannerBlock', new ShopBannerBlock($(this)));
    })
  }
  calculateScroll(){
    var __this=this;
    var winWidth=$(window).width();
    var winHeight=$(window).height();
    var xLength=this.block.position().left+this.block.width()-winWidth;
    this.totalDistance=xLength;
    var totalHeight=winHeight+this.totalDistance;
    this.wrapper.height(totalHeight);
    this.start=this.el.offset().top;
    this.end=this.start+this.totalDistance;
  }
  runScroll(){
    if(scrollTop<this.start){
      this.distance=0;
      this.el.attr('data-mode', 'static');
    } else if(scrollTop>this.end){ 
      this.distance=this.totalDistance;
      this.el.attr('data-mode', 'absolute');
    } else {
      this.distance=scrollTop-this.start;
      this.el.attr('data-mode', 'fixed');
    }
  }
  runAnimation(){
    var __this=this;
    var distance=-1*this.distance;
    
    var currX=(this.lerp(this.currX, distance, .05));
    this.cont.each(function(){
      $(this).css('left', currX);
    })
    this.currX=currX; 
    window.requestAnimationFrame(function() { __this.runAnimation(); });
  }
  lerp(a, b){
    return(a+((b-a)*.1));
  }
}

class ShopBannerBlock {
  constructor(el){
    var __this=this;
    this.el=el;
    this.cnt=this.el.find('span.cnt');
    this.rel=this.el.find('.bundle-block');
    this.el.hover(function(){
      __this.setCounts(1);
    }, function(){
      __this.setCounts(0);
    });
  }
  setCounts(mode){
    var __this=this;
    this.cnt.each(function(index){
      if(mode) {
        var top=$(this).position().top;
        var elTop=__this.rel.eq(index).position().top;
        var diff=elTop-top;
        $(this).css('transform', 'translateY('+diff+'px)');
      }else {
        $(this).css('transform', 'translateY(0)');
      }
    })
  }
}

class AboutSplit {
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.heightEl=this.el.find('.grid--new').first();
    this.block=this.el.find('.block');
    this.inner=this.block.find('> div');
    
    $(window).on('scroll resize', function(){
      __this.calculateLimits();
      __this.runScroll();
    })
    
    this.calculateLimits();
    this.runScroll();
  }
  calculateLimits(){
    this.top=this.el.offset().top;
    this.bottom=this.top+this.heightEl.outerHeight()-this.inner.height();
    this.inner.width(this.block.width());
    console.log(this.top+'    ---- '+this.bottom);
  }
  runScroll(){
    if(scrollTop<this.top) {
      this.el.attr('data-mode', 'static');
    }else if(scrollTop>this.bottom) {
      this.el.attr('data-mode', 'absolute');
    }else{
      this.el.attr('data-mode', 'fixed');
    }
  }
}

class SetSizes {
  constructor(){
    var __this=this;
    this.el=$('[data-section-type="header"]');
    this.sizeString='.product-block--option span[variant], [class*="options-size"] a[data-value]';
    this.sizes=$(this.sizeString);
    this.size=this.el.find('#sizes');
    this.cont=this.el.find('#sizes .container');
    this.inner=this.el.find('#sizes .inner');
    this.btn=this.el.find('#sizes a');
    this.active=0;
    this.runInit();
    $(window).on('resize', function(){
      __this.setBase();
      __this.active=0;
    })
    $(window).on('filterComplete', function(){
      setTimeout(function(){ 
        __this.sizes=$(__this.sizeString);
        __this.runInit(); }, 250);
    });
    $('body').on('click', function(e){
      var el=$(e.target);
      if(!isMobile){
        if(el.closest('.size--btn').length) {
          e.preventDefault();
          __this.runCountry(el);
        } 
        return;
      }
      if(!__this.active) {
        if(el.closest('#sizes').length) {
          e.preventDefault();
          __this.active=1;
          __this.setHover();
          return;
        }
      }
      if(__this.active) {
        if(el.closest('.size--btn').length) {
          e.preventDefault();
          __this.runCountry(el);
          __this.setBase();
          __this.active=0;
          return
        }
        if(!el.closest('#sizes').length) {
          e.preventDefault();
          __this.setBase();
          __this.active=0;
        }
      }
    })
    
    this.cont.hover(function(){
      if(!isMobile) __this.setHover();
    }, function(){
      if(!isMobile) __this.setBase();
    })
  }
  setHover(){
    if(!isMobile) this.cont.width(this.inner.width());
    else this.cont.height(this.inner.height());
    
    if(!isMobile) this.inner.css('transform', 'translateX(0)');
    else this.inner.css('transform', 'translateY(0)');
  }
  setBase(){
    var active=this.size.find('.active');
    if(!isMobile) {
      this.size.height('auto')
      this.cont.width(active.outerWidth());
    } else {
      this.size.height(Math.abs(active.outerHeight()));
      this.cont.height(Math.abs(active.outerHeight()));
    }
    var intLeft=active.parent().offset().left-active.offset().left;
    var intTop=active.parent().offset().top-active.offset().top;
    if(!isMobile) this.inner.css('transform', 'translateX('+intLeft+'px)');
    else this.inner.css('transform', 'translateY('+intTop+'px)');
  }
  runCountry(el) {
    var __this=this;
    this.country=el.attr('value');
    try { window.localStorage.setItem('size_country_user', this.country); } catch(e) {}
    this.runSizes();
  }
  runInit(){
    var __this=this;
    // 1. A size region the shopper picked by hand always wins.
    var saved=null;
    try { saved=window.localStorage.getItem('size_country_user'); } catch(e) {}
    if(saved){
      this.country=saved;
      this.runSizes();
      this.setBase();
      return;
    }
    // 2. Region already detected in this browser session.
    var cached=null;
    try { cached=window.sessionStorage.getItem('size_country_geo'); } catch(e) {}
    if(cached){
      this.country=cached;
      this.runSizes();
      this.setBase();
      return;
    }
    // 3. Detect the visitor's country with Shopify's own geolocation.
    var finish=function(code){
      __this.testCountry(code ? String(code).toUpperCase() : undefined);
      try { window.sessionStorage.setItem('size_country_geo', __this.country); } catch(e) {}
      __this.runSizes();
      __this.setBase();
    };
    var shopifyCountry=(window.Shopify && window.Shopify.country) ? String(window.Shopify.country).toUpperCase() : undefined;
    // The visitor is in a non-AU market (e.g. aurocea.com/en-us), so use that market's country.
    if(shopifyCountry && shopifyCountry!=='AU'){
      finish(shopifyCountry);
      return;
    }
    // Default (AU) market: ask Shopify which country the visitor is actually in.
    $.ajax({
      url: '/browsing_context_suggestions.json',
      data: { 'country[enabled]': true },
      dataType: 'json',
      timeout: 4000
    }).done(function(r){
      var detected=r && r.detected_values && r.detected_values.country && r.detected_values.country.handle;
      finish(detected || shopifyCountry);
    }).fail(function(){
      finish(shopifyCountry);
    });
  }
  testCountry(country){
    
    if(typeof(country)=='undefined'){
      this.country='AU';
      return;
    }
    
    if(country=='AU' || country=='NZ') {
      this.country='AU';
    }else if(country=='US' || country=='CA') {
      this.country='US';
    }else if(country=='GB') {
      this.country='UK'
    } else {
      this.country='EU'
    }
  }
  runSizes(){
    var __this=this;
    
    $('#sizes a[value="'+this.country+'"]')
      .addClass('active')
      .siblings().removeClass('active');
      
    this.sizes.each(function(){
      var val=typeof $(this).attr('value')=='undefined' ? $(this).attr('data-value') : $(this).attr('value');
      if(val.indexOf(__this.country)==-1) return;
      var newVal=val.split(__this.country)[1];
      newVal=newVal.split(' ')[0];
      newVal=__this.country+newVal;
      var strong=$(this).find('strong');
      if(strong.length) strong.text(newVal);
      else $(this).text(newVal);
    })
  }
}

function iconChevronDown(){
  return'<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22.9 22.8" style="enable-background:new 0 0 22.9 22.8;" xml:space="preserve"><style type="text/css">.st0{fill:none;stroke:#3A2426;stroke-width:0.25;}</style><polyline class="st0" points="3.3,8 11.4,16.1 19.3,8.2 "/></svg>';
}

var isMobile=0;
var scrollTop=$(window).scrollTop();
var scrollBottom=scrollTop+$(window).height();

$( function(){
  
  //theme.init();
  
  $('body,html').on('load', function(){
    $(this).trigger('retrigger');
    $(window).trigger('retrigger');
  });
  
  document.documentElement.style.setProperty('--window-base-height', $(window).height()+'px');
  
  $(document).ready(function() {
    
    scrollTop=$(window).scrollTop();
    scrollBottom=scrollTop+$(window).height();
    
    $('body.template-product .product-detail__tab-container').each(function(){
      $(this).data('data-height', new TabHeight($(this)));
    })
    
    $(window).on('scroll', function(){
      scrollTop=$(window).scrollTop();  
      scrollBottom=scrollTop+$(window).height();
    })
    if($('body').is('[class*="page-"]')) {
      if($('meta.padding').length) $('body').addClass('page--marginless'); 
    }
    $('.section-banner-columns .scroll-block').each(function(){
      $(this).data('data-scroll', new BannerH2($(this)));
    })
    
    $('#page-menu .has-children').each(function(){
      $(this).data('MobileMenuItem', new MobileMenuItem($(this)));
    })
    
    //setTimeout( function() { new Related(); }, 250 );
    
    $('.data-visibility').each(function(){
      $.data($(this), 'visibility', new ElementVisibility($(this)));
    })
    new PageScroll();
    new CartDrawer();
    new MobileCheck();
    
    $('.cc-announcement--slider').each(function(){
      $.data($(this), 'slider', new AnnouncementSlider($(this)));
    })
    $('.cc-announcement--multi').each(function(){
      $.data($(this), 'slider', new AnnouncementMulti($(this)));
    })
    $('.muse-products').each(function(){
      $.data($(this), 'carousel', new MuseProducts($(this)));
    })
    
    $('.cc-featured-muse').each(function(){
      $.data($(this), 'featured', new MuseFeatured($(this)));
    })
    $('.cc-featured-muse h2, .muse-hr').each(function(){
      $.data($(this), 'h2', new MuseH2($(this)));
    })
    $('.cc-muse--block').each(function(){
      $.data($(this), 'block', new MuseBlock($(this)));
    })
    $('.article-gallery').each(function(){
      $.data($(this), 'gallery', new ArticleGallery($(this)));
    })
    $('.article-banner').each(function(){
      $.data($(this), 'banner', new ArticleBanner($(this)));
    })
    $('img').on('load', function(){
      $(window).trigger('retrigger');
    });
    
    $('.product-area__thumbs').each( function(){
      $.data($(this), 'ProductScroll', new ProductScroll($('.product-area__thumbs'), $('.product-area__thumbs__inner')));
    } )
    
    $('.product-details').each(function(){
      $.data($(this), 'ProductScroll', new ProductScroll($('.product-details'), $('.product-details--inner')));
    } )
    
    $( '.product-form' ).each( function(){
      $.data( $( this ), 'ProductScroll', new ProductScroll( $( '.product-form' ), $( '.product-form--inner' ) ) );
    } )
    
    $('.cc-product-filter-box').each( function(){
      $.data($(this), 'boxScroll', new BoxScroll('.cc-product-filter-wrapper', '.cc-product-filter-box', '.product-list-container'));
      $.data($(this), 'filterBtn', new FilterState());
    })
    $('.section-anchor--block').each( function(){
      $.data($(this), 'boxScroll', new BoxScroll('.section-anchor--block', '.section-anchor--container', '#page-content'));
      $.data($(this), 'anchorBlock', new AnchorBlock($(this)));
    });
    $('.proxy--tag').each( function(){
      $.data($( this), 'filter-tag', new ProxyTag($(this)));
    });
    
    $('.template-article').each(function(){
      new ArticleImages();
    })
    $('[data-new-modal-toggle').each(function(){
      var a=$(this);
      $.data(a, 'newModalToggle', new ModalToggle(a));
    })
    
    new ScrollClass();  
    new ScrollMenu();

     $('.cc-announcement--multi').each(function(){
      $.data($(this), 'slider', new AnnouncementMulti($(this)));
    })

    $('.cc-announcement--slider').each(function(){  
      $.data($(this), 'slider', new AnnouncementSlider($(this)));
    })
    
    $('[data-section-scroll]').each(function(){
      $(this).data('scroll', new SectionScroll($(this)));
    });
    
    $('.size-chart-insert').each(function(){
      $('#shopify-section-size-chart .size-chart').clone().appendTo($(this));
    })
    $('.size-chart').each(function(){
      $.data($(this), 'chart', new SizeChart($(this)));
    })
    $('.section-spotlight').each(function(){
      $.data($(this), 'spotlight', new SpotLight($(this)));
    })
    $('.section-intro-banner-columns').each(function(){
      $.data($(this), 'spotlight', new IntroBlock($(this)));
    })
    $('.section-shop-banner:not(.section-shop-banner--edit)').each(function(){
      $.data($(this), 'shopbanner', new ShopBanner($(this)));
    })
    $('.bundle-overlay').each(function(){
      $.data($(this), 'bundleOverlay', new BundleOverlay($(this)));
    })
    $('.bundle-block').each(function(){
      $.data($(this), 'bundle', new Bundle($(this)));
    })
    //$('.carousel-ig').each(function(){
    $('.instagram-feed').each(function(){
      $.data($(this), 'carousel', new CarouselInstagram($(this)));
    });
    $('.section-about-split').each(function(){
      $.data($(this), 'split', new AboutSplit($(this)));
    });
    new SetSizes();
  });
  $(document).ready(function () {
  
    function checkCookie(){
      
      if ($.cookie) {
        initial();
      } else {
        setTimeout(() => {
          checkCookie();
        }, 500);
      }
    }
    checkCookie();
    
    function initial(){
    var has_selected = $.cookie("has_selected_country");
    
    if(has_selected && has_selected !== 'null'){
      
        if(window.localStorage.getItem('has_relocated') === "true"){
          return;
        }else{
        if(window.localStorage.getItem('preferred_url') && window.localStorage.getItem('preferred_url')!== window.location.href ){
          window.localStorage.setItem('has_relocated',true);
          window.location.href = window.localStorage.getItem('preferred_url');
        }
      }
    }else{
      
      window.localStorage.setItem('has_relocated',false);
      
      var country_list = [];
      $('.geo_popup-countries .country').each(function () {  
          var data = {};
          var country_code = $(this).attr('data-country');
          var country_url = $(this).attr('data-base_url');
          data.code  = country_code;
          data.url = country_url;
          country_list.push(data);
      });
      
    if(window.localStorage.getItem('current_country')){
      setPopup(window.localStorage.getItem('current_country'))
    }else{
      
      $.get("https://ipinfo.io?token=5e71f36bd3d242", function (response) { 
        console.log('here333');
        console.log('country '+response);
        setPopup(response.country)
      
      }, "jsonp");
    }
  
    function setPopup(country){
      
      window.localStorage.setItem('current_country',country);
          var show_popup = true,
          user_country = country,
          user_country_url,
          url = window.location.href,
          base_url = window.location.origin;
          // pathName = url.split(base_url);
  
          country_list.forEach(country_data=>{
              if(country_data.code === user_country){
                  user_country_url = country_data.url;
              }
          })
          if(base_url !== user_country_url){
              // Show popup
            if ($.cookie("has_selected_country") == null || $.cookie("has_selected_country") == "null") {
  
              var this_country_url;
                  $('.geo_popup-countries .country').each(function () {  
                      var country_code = $(this).attr('data-country');
                      var country_url = $(this).attr('data-url');
                      var country_name = $(this).text();
                      if(country_code === user_country){
                          $('#selected_country').text(country_name);
                          $('#selected_country').attr('data-url', country_url);
                          this_country_url = country_url;
                      }
                  });
  
                  $(".geo_popup-container").addClass("model-open");
                  $(".close-btn, .bg-overlay").click(function () {
                      $(".geo_popup-container").removeClass("model-open");
                  });
                 var date = new Date();
                 var minutes = 10;
                 date.setTime(date.getTime() + (minutes * 60 * 1000));
                  $.cookie("has_selected_country", 1, {
                    expires: date,
                    path: "/"});
            }
            }
  
          
    }
      // Set up redirect button
      $(document).on('click','.geo_popup-container .redirect_btn', function () {
        window.localStorage.setItem('preferred_url',$('#selected_country').attr('data-url'));
        window.localStorage.setItem('has_relocated',true);
        window.location.href = $('#selected_country').attr('data-url');
        
      });
  
      // Set up countries dropdown
      $(document).on('click','#selected_country', function () {  
          $('.geo_popup-countries ul').toggleClass('active');
      });
  
      $(document).on('click','.geo_popup-countries ul li', function () {  
          $('.geo_popup-countries ul').removeClass('active');
  
          var country = $(this).text();
          var country_url = $(this).attr('data-url');
  
          $('#selected_country').text(country);
          $('#selected_country').attr('data-url',country_url);
      });
    }
    }
  });
})